/* ==========================================================================
   Deco Garden Adventure — game engine + logic (vanilla JS, no dependencies)
   --------------------------------------------------------------------------
   100% original art (drawn procedurally on Canvas) and original synthesized
   audio (WebAudio). Real product data + images come from Shopify via the
   section's JSON blocks. Cart uses Shopify's Cart AJAX API.

   Public-ish surface: window.DecoGardenAdventure.version
   Each [data-dga-root] becomes an independent game instance.
   ========================================================================== */
(function () {
  'use strict';

  var BUILD = '1.0.0';
  window.DecoGardenAdventure = { version: BUILD };

  // -- tiny DOM helpers ------------------------------------------------------
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function on(node, ev, fn, opt) { node.addEventListener(ev, fn, opt || false); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rand(s) { /* mulberry32 seeded RNG */ return function () { s |= 0; s = s + 0x6D2B79F5 | 0; var t = Math.imul(s ^ s >>> 15, 1 | s); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

  // Boot every instance once DOM is ready (script is deferred, so it is).
  document.querySelectorAll('[data-dga-root]').forEach(function (root) {
    try { initGame(root); }
    catch (e) {
      if (window.console) console.warn('[DGA] init failed', e);
      var boot = root.querySelector('[data-dga-boot]');
      if (boot) boot.innerHTML = '<p>אפשר להמשיך לקנייה רגילה 🌿</p>';
    }
  });

  // ==========================================================================
  //  ONE GAME INSTANCE
  // ==========================================================================
  function initGame(root) {
    if (root.__dga) return; root.__dga = true;

    var cfg = JSON.parse(root.querySelector('[data-dga-config]').textContent);
    var zones = JSON.parse(root.querySelector('[data-dga-zones]').textContent) || [];
    var sectionId = root.getAttribute('data-section-id') || 'x';
    var SAVE_KEY = 'dga:v1:' + sectionId;

    var frame = root.querySelector('[data-dga-frame]');
    var canvas = root.querySelector('[data-dga-canvas]');
    var overlays = root.querySelector('[data-dga-overlays]');
    var liveEl = root.querySelector('[data-dga-live]');
    var bootEl = root.querySelector('[data-dga-boot]');
    var ctx = canvas.getContext('2d', { alpha: false });

    // ---- i18n (Hebrew now; structure ready for Russian etc.) ---------------
    var DICT = {
      he: {
        level: 'רמה', coins: 'מטבעות', menu: 'תפריט', map: 'מפה', resume: 'חזרה למשחק',
        sound_on: 'סאונד פעיל', sound_off: 'סאונד כבוי',
        free_ship: 'משלוח חינם', to_free_ship: 'עוד {x} למשלוח חינם', free_ship_hit: 'יש! הגעתם למשלוח חינם 🚚',
        add_to_cart: 'הוסף לעגלה', added: 'נוסף לעגלה!', adding: 'מוסיף…', view_product: 'לעמוד המוצר',
        difficulty: 'קושי', watering: 'השקיה', light: 'אור', suits: 'מתאים ל', care: 'טיפ',
        suit_home: 'בית', suit_garden: 'גינה', suit_both: 'בית וגינה',
        action: 'פעולה', start_game: 'יוצאים להרפתקה', continue_game: 'המשך משחק',
        pace: 'קצב', pace_explore: 'חופשי 🌿', pace_challenge: 'אתגר ⏱️',
        calm: 'מצב רגוע', audio: 'סאונד', reduce_motion: 'פחות תנועה', contrast: 'ניגודיות', text_size: 'גודל טקסט',
        accessibility: 'נגישות', settings: 'הגדרות', minigames: 'מיני-משחקים', restart: 'התחלה מחדש',
        finish: 'סיום וסיכום', skip: 'דלגו לקנייה רגילה',
        zone_enter: 'נכנסתם ל{x}', level_up: 'עלית לרמה {x}!', play: 'שחק', skip_mg: 'דלג',
        win: 'כל הכבוד! 🎉', try_again: 'עוד פעם', reward_coins: '+{x} מטבעות',
        gift_title: 'מתנה בשבילכם!', gift_open: 'פתחו את המתנה', copy: 'העתק קוד', copied: 'הועתק! ✓',
        apply_checkout: 'החל בקופה', your_code: 'קוד ההנחה שלכם',
        end_title: 'סיימת את המשחק!', time_played: 'זמן משחק', plants_found: 'צמחים שגילית',
        treasures: 'אוצרות', cleared: 'מיני-משחקים', cart_summary: 'העגלה שלך', checkout: 'מעבר לתשלום',
        keep_playing: 'ממשיכים לשחק', empty_cart: 'העגלה ריקה — הוסיפו צמחים מהמשחק!',
        daily_title: 'מתנת כניסה יומית 🎁', daily_claim: 'אסוף מתנה', daily_got: 'קיבלת {x} מטבעות!',
        treasure_found: 'מצאת אוצר! +{x} מטבעות', come_back: 'חזרו מחר למתנה חדשה!',
        coming_soon: 'בקרוב — האזור הזה מתמלא 🌱', go_gate: 'לשער (מעבר אזורים)',
        can_finish: 'אפשר לסיים ולקבל פרס בכל רגע — מהתפריט', interact_hint: 'התקרבו ולחצו פעולה',
        feed: 'הזן', squash: 'מחץ!', water_now: 'השקה', diagnose: 'אבחן', root_it: 'השריש', next: 'הבא',
        recommend: 'הפתרון שלנו:', drag_hint: 'גררו למקום הנכון', tap_stop: 'לחצו לעצירה במקום הנכון',
        skip_intro: 'דלג על הפתיחה ⏭', intro_say: 'נכנסים למשתלה הקסומה…', quest: 'משימה',
        quest_started: 'משימה חדשה: סיירו, עזרו ל-3 צמחים, מלאו עגלה', quest_ready: 'אפשר לחזור לנץ לסיום!',
        quest_meet_npc: 'דברו עם נץ ליד הכניסה', quest_visit: 'בקרו בעוד {x} אזורים', quest_help: 'עזרו לעוד {x} צמחים (מיני-משחקים)', quest_cart: 'מלאו את העגלה לקראת משלוח חינם', quest_done_hint: 'חזרו לנץ לסיום 🌸',
        quest_title_text: 'עזרו למשתלה להתעורר לאביב:', quest_q_meet: 'פגשו את נץ, שומר הגן', quest_q_visit: 'סיירו בכל האזורים ({a}/{b})', quest_q_help: 'עזרו ל-3 צמחים ({a}/3)', quest_q_cart: 'מלאו את העגלה (משלוח חינם)'
      },
      ru: {} // add Russian strings here later (falls back to Hebrew)
    };
    var LANG = (cfg.locale === 'ru' && DICT.ru) ? 'ru' : 'he';
    function t(k, vars) {
      var s = (DICT[LANG] && DICT[LANG][k]) || DICT.he[k] || k;
      if (vars) for (var p in vars) s = s.replace('{' + p + '}', vars[p]);
      return s;
    }

    // ---- persistent state --------------------------------------------------
    var S = {
      level: 1, xp: 0, coins: 0, zoneIndex: 0,
      discovered: {}, treasureIds: {}, treasures: 0,
      mgCleared: {}, zonesVisited: {}, codes: {},
      pace: 'explore', calm: !!cfg.calmDefault, muted: false,
      reduced: false, contrast: false, textScale: 1,
      cosmetic: 0, finished: false, playMs: 0
    };
    function load() {
      try {
        var raw = localStorage.getItem(SAVE_KEY);
        if (raw) { var o = JSON.parse(raw); for (var k in o) if (k in S) S[k] = o[k]; }
      } catch (e) {}
    }
    function save() {
      try { localStorage.setItem(SAVE_KEY, JSON.stringify(S)); } catch (e) {}
    }
    function count(obj) { var n = 0; for (var k in obj) if (obj[k]) n++; return n; }

    // ---- analytics ---------------------------------------------------------
    function fire(name, payload) {
      payload = payload || {};
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'dga_' + name }, payload)); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('dga_' + name, payload); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent('dga:' + name, { detail: payload })); } catch (e) {}
    }

    // ---- audio (synth; autoplay-safe — only after first gesture) -----------
    var Audio2 = (function () {
      var actx = null, master = null, musicTimer = null, started = false;
      function ensure() {
        if (actx || !cfg.audio) return;
        try {
          actx = new (window.AudioContext || window.webkitAudioContext)();
          master = actx.createGain(); master.gain.value = S.muted ? 0 : 0.5; master.connect(actx.destination);
        } catch (e) { actx = null; }
      }
      function tone(freq, dur, type, vol, when) {
        if (!actx || S.muted) return;
        var o = actx.createOscillator(), g = actx.createGain();
        o.type = type || 'sine'; o.frequency.value = freq;
        var t0 = (when || actx.currentTime);
        g.gain.setValueAtTime(0, t0);
        g.gain.linearRampToValueAtTime(vol || 0.3, t0 + 0.01);
        g.gain.exponentialRampToValueAtTime(0.0001, t0 + (dur || 0.18));
        o.connect(g); g.connect(master); o.start(t0); o.stop(t0 + (dur || 0.18) + 0.02);
      }
      var scale = [0, 2, 4, 7, 9, 12, 14]; // pentatonic-ish, gentle
      function sfx(name) {
        ensure(); if (!actx) return;
        var n = actx.currentTime;
        switch (name) {
          case 'step': tone(120, 0.06, 'sine', 0.05); break;
          case 'pickup': tone(523, 0.1, 'triangle', 0.25); tone(784, 0.12, 'triangle', 0.2, n + 0.07); break;
          case 'cart': tone(523, 0.1, 'triangle', 0.25); tone(659, 0.1, 'triangle', 0.25, n + 0.06); tone(880, 0.16, 'triangle', 0.22, n + 0.12); break;
          case 'level': [523, 659, 784, 1046].forEach(function (f, i) { tone(f, 0.18, 'triangle', 0.25, n + i * 0.09); }); break;
          case 'win': [523, 784, 1046, 1318].forEach(function (f, i) { tone(f, 0.2, 'square', 0.18, n + i * 0.08); }); break;
          case 'error': tone(180, 0.18, 'sawtooth', 0.18); tone(120, 0.22, 'sawtooth', 0.16, n + 0.08); break;
          case 'gift': [880, 1175, 1568].forEach(function (f, i) { tone(f, 0.16, 'sine', 0.2, n + i * 0.06); }); break;
          case 'bug': tone(300, 0.08, 'square', 0.2); break;
          case 'coin': tone(988, 0.08, 'square', 0.18); tone(1319, 0.1, 'square', 0.16, n + 0.05); break;
        }
      }
      function startMusic() {
        ensure(); if (!actx || musicTimer || S.muted || !cfg.audio) return;
        started = true;
        var step = 0, root = 196; // G3
        musicTimer = setInterval(function () {
          if (!actx || S.muted) return;
          var deg = scale[(step * 2) % scale.length];
          var f = root * Math.pow(2, deg / 12);
          tone(f, 0.5, 'sine', 0.06);
          if (step % 4 === 0) tone(root / 2, 0.6, 'triangle', 0.05); // soft bass
          step++;
        }, 620);
      }
      function stopMusic() { if (musicTimer) { clearInterval(musicTimer); musicTimer = null; } }
      function setMute(m) {
        if (master) master.gain.value = m ? 0 : 0.5;
        if (m) stopMusic(); else if (started) startMusic();
      }
      function setAmbient(kind) {
        ensure(); if (!actx || S.muted || !cfg.audio) return;
        var n = actx.currentTime;
        var m = { greenhouse: [523, 659], sun: [587, 784], desert: [392, 494], tropical: [440, 554], climbers: [494, 659], fertilizer: [349, 440], pests: [392, 523], hardy: [440, 587], pots: [349, 466], gifts: [523, 698] }[kind] || [523, 659];
        tone(m[0], 0.4, 'sine', 0.07, n); tone(m[1], 0.5, 'sine', 0.06, n + 0.18);
      }
      return { sfx: sfx, startMusic: startMusic, stopMusic: stopMusic, setMute: setMute, ensure: ensure, setAmbient: setAmbient };
    })();

    // ---- world constants ---------------------------------------------------
    var T = 32;                 // world px per tile
    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var viewW = 0, viewH = 0, scale = 1, ox = 0, oy = 0;
    var cam = { x: 0, y: 0 };

    // Per-habitat look + ambient (premium illustrated palette, light-isometric)
    var THEMES = {
      greenhouse: { g1: '#f1e6d2', g2: '#e9dcc1', grout: '#d7c3a3', fence: '#8a6f4d', wood: '#a9794a', deco: '🌿', accent: '#2fae6b', glass: true,  ambient: 'butterflies' },
      sun:        { g1: '#e7f0c2', g2: '#dce8b0', grout: '#c9dd96', fence: '#9fae5e', wood: '#b07f4c', deco: '🌻', accent: '#e8b53a', glass: false, ambient: 'bees' },
      desert:     { g1: '#f2dca6', g2: '#ead08f', grout: '#dcc07e', fence: '#caa86a', wood: '#b78a52', deco: '🌵', accent: '#e09a3a', glass: false, ambient: 'heat' },
      tropical:   { g1: '#bfe0c2', g2: '#aed7b2', grout: '#94c79a', fence: '#5a7d3a', wood: '#7a5836', deco: '🌴', accent: '#1f8f5a', glass: false, ambient: 'drips' },
      climbers:   { g1: '#e0e9cc', g2: '#d4e0bc', grout: '#c2d2a6', fence: '#9a7444', wood: '#9a7444', deco: '🌿', accent: '#7a9a4a', glass: false, ambient: 'butterflies' },
      pavilion:   { g1: '#e8e0d2', g2: '#ded3c0', grout: '#cabfa6', fence: '#b2906a', wood: '#b2906a', deco: '🧰', accent: '#b08a55', glass: false, ambient: 'none' },
      fertilizer: { g1: '#e8ddcb', g2: '#ddd0b9', grout: '#cabf9f', fence: '#a9885a', wood: '#a9885a', deco: '🧪', accent: '#9a7a45', glass: false, ambient: 'none' },
      pests:      { g1: '#e3ead6', g2: '#d6e1c6', grout: '#c4d2ad', fence: '#8aa86a', wood: '#9a7a4a', deco: '🐞', accent: '#7a9a4a', glass: false, ambient: 'butterflies' },
      hardy:      { g1: '#deebcc', g2: '#d2e2bd', grout: '#c0d3a6', fence: '#8fa85f', wood: '#9a7a4a', deco: '🌱', accent: '#6fae5a', glass: false, ambient: 'butterflies' },
      pots:       { g1: '#ecdfca', g2: '#e1d2b8', grout: '#cebf9e', fence: '#b2906a', wood: '#b2906a', deco: '🏺', accent: '#b07a45', glass: false, ambient: 'none' },
      gifts:      { g1: '#f1e2ee', g2: '#e7d3e3', grout: '#d8bdd0', fence: '#c79ab8', wood: '#b2906a', deco: '🎁', accent: '#c77ab0', glass: false, ambient: 'fireflies' }
    };
    var ZONE_EMOJI = { greenhouse: '🏡', sun: '☀️', desert: '🌵', tropical: '🌴', climbers: '🪴', pavilion: '🧰', fertilizer: '🧪', pests: '🐞', hardy: '🌱', pots: '🏺', gifts: '🎁' };
    var MG_EMOJI = { fertilizer: '🧪', pests: '🐞', repotting: '🏺', watering: '💧', light: '☀️', doctor: '🩺', propagation: '🌿', trivia: '❓' };
    var MG_TITLE = {
      fertilizer: 'תחנת הדישון', pests: 'הדברה ידידותית', repotting: 'החלפת עציץ', watering: 'אתגר ההשקיה',
      light: 'התאמת אור', doctor: 'רופא הצמחים', propagation: 'ריבוי בייחור', trivia: 'חידון צמחים'
    };

    // ---- build per-zone maps ----------------------------------------------
    if (!zones.length) {
      if (bootEl) bootEl.innerHTML = '<p>הוסיפו אזורים (בלוקים) למשחק דרך עורך הערכה 🌱</p>';
      return;
    }
    // ==========================================================================
    //  ONE CONTINUOUS COMPOUND
    // ==========================================================================
    var world = { cols: 0, rows: 0, wpx: 0, hpx: 0, solid: null, avenueY: 0, AV: 3, npc: null, spawn: null, entrance: null, aveBg: null };
    var imgCache = {}; // global product image cache (lazy)
    var PER_BENCH = 8, BCOLS_MAX = 3;

    buildWorld();

    function buildWorld() {
      // 1) plot dimensions from product count
      zones.forEach(function (z) {
        var n = z.products.length;
        var nb = Math.max(1, Math.ceil(n / PER_BENCH));
        z._nb = nb;
        z._bcols = Math.min(BCOLS_MAX, Math.max(1, Math.min(nb, Math.ceil(Math.sqrt(nb)))));
        z._brows = Math.ceil(nb / z._bcols);
        z._iw = Math.max(10, z._bcols * 5 + 2);
        z._ih = Math.max(9, z._brows * 4 + 4);
      });
      // 2) arrange plots left->right, alternating above/below a central avenue
      var AV = 3, gap = 2, x = 3, maxAbove = 0, maxBelow = 0;
      zones.forEach(function (z, i) {
        z._above = (i % 2 === 0);
        z._pw = z._iw + 2; z._ph = z._ih + 2;
        z._px = x;
        if (z._above) maxAbove = Math.max(maxAbove, z._ph); else maxBelow = Math.max(maxBelow, z._ph);
        x += z._pw + gap;
      });
      var cols = x + 3, avenueY = maxAbove + 1, rows = maxAbove + AV + maxBelow + 2;
      zones.forEach(function (z) { z._py = z._above ? (avenueY - z._ph) : (avenueY + AV); });
      world.cols = cols; world.rows = rows; world.wpx = cols * T; world.hpx = rows * T;
      world.avenueY = avenueY; world.AV = AV;

      // 3) collision grid: solid everywhere, carve avenue + interiors + doors
      var solid = []; for (var r = 0; r < rows; r++) { solid[r] = []; for (var c = 0; c < cols; c++) solid[r][c] = true; }
      for (var avr = avenueY; avr < avenueY + AV; avr++) for (var avc = 1; avc < cols - 1; avc++) solid[avr][avc] = false;
      world.solid = solid;
      world.spawn = { x: 3.5 * T, y: (avenueY + 1) * T + T / 2 };
      world.entrance = { x: 1.2 * T, y: (avenueY + 1) * T + T / 2 };

      // 4) build each plot
      zones.forEach(function (z, i) {
        z._i = i;
        var x0 = z._px + 1, y0 = z._py + 1, x1 = z._px + z._pw - 1, y1 = z._py + z._ph - 1;
        z.bounds = { x0: x0, y0: y0, x1: x1, y1: y1, px: z._px, py: z._py, pw: z._pw, ph: z._ph };
        z.cx = (z._px + z._pw / 2) * T; z.cy = (z._py + z._ph / 2) * T;
        for (var r = y0; r < y1; r++) for (var c = x0; c < x1; c++) solid[r][c] = false;
        // door: 3-wide opening centered, connecting the plot to the avenue
        var doorC = clamp(Math.round((x0 + x1) / 2), x0 + 1, x1 - 2);
        z._doorC = doorC;
        if (z._above) { for (var dc = doorC - 1; dc <= doorC + 1; dc++) for (var rr = y1; rr < avenueY; rr++) solid[rr][dc] = false; z.doorPx = { x: doorC * T + T / 2, y: y1 * T }; }
        else { for (var dc2 = doorC - 1; dc2 <= doorC + 1; dc2++) for (var rr2 = avenueY + AV; rr2 <= z._py; rr2++) solid[rr2][dc2] = false; z.doorPx = { x: doorC * T + T / 2, y: z._py * T }; }
        // benches + product slots
        z.benchObjs = []; var pi = 0;
        for (var br = 0; br < z._brows; br++) {
          for (var bc = 0; bc < z._bcols && pi < Math.max(z.products.length, 1); bc++) {
            var bx = x0 + 1 + bc * 5, by = y0 + 1 + br * 4;
            for (var sr = by; sr < by + 2 && sr < rows; sr++) for (var sc = bx; sc < bx + 4 && sc < cols; sc++) solid[sr][sc] = true;
            var bench = { x: bx * T, y: by * T, w: 4 * T, h: 2 * T, cx: (bx + 2) * T, cy: (by + 1) * T, slots: [] };
            for (var tier = 0; tier <= 1 && pi < z.products.length; tier++) {
              for (var k = 0; k < 4 && pi < z.products.length; k++) {
                var p = z.products[pi++];
                bench.slots.push({ p: p, x: bx * T + 14 + k * ((4 * T - 28) / 3), y: by * T + (tier === 1 ? 14 : 34), tier: tier });
              }
            }
            bench.slots.sort(function (a, b) { return a.y - b.y; });
            z.benchObjs.push(bench);
          }
        }
        if (z.minigame && z.minigame !== 'none') z.station = { cx: (x0 + 0.7) * T, cy: (y0 + 0.7) * T, type: z.minigame };
        var th = THEMES[z.theme] || THEMES.greenhouse;
        z.decoObjs = [];
        [[x0 + 0.5, y1 - 0.6], [x1 - 0.6, y1 - 0.6]].forEach(function (cc) { z.decoObjs.push({ x: cc[0] * T, y: cc[1] * T, emoji: th.deco, sway: Math.random() * 6.28 }); });
        z.treasures = [];
        if (i % 2 === 0) {
          var rng = rand((z.id ? z.id.length : 1) * 97 + i * 13);
          var trc = x0 + 1 + Math.floor(rng() * Math.max(1, x1 - x0 - 2)), trr = y0 + 2 + Math.floor(rng() * Math.max(1, y1 - y0 - 3));
          if (solid[trr] && !solid[trr][trc]) z.treasures.push({ cx: trc * T + T / 2, cy: trr * T + T / 2, key: z.id + ':t' });
        }
        z.ambient = th.ambient;
        z.creatures = [];
        if (z.theme === 'tropical') {
          var ptx = clamp(x0 + 1, x0 + 1, x1 - 2), pty = clamp(y1 - 3, y0 + 1, y1 - 2);
          for (var pr = pty; pr < pty + 2; pr++) for (var pc = ptx; pc < ptx + 2; pc++) { if (solid[pr]) solid[pr][pc] = true; }
          z.pond = { x: ptx * T, y: pty * T, w: 2 * T, h: 2 * T, cx: (ptx + 1) * T, cy: (pty + 1) * T };
          for (var ki = 0; ki < 3; ki++) z.creatures.push({ kind: 'koi', a: ki * 2, r: 6 + ki * 6, sp: 0.7 + ki * 0.2, col: ['#e8743a', '#f0c24a', '#fafafa'][ki] });
        } else if (z.theme === 'desert') {
          z.creatures.push({ kind: 'tortoise', x: z.cx, y: z.cy, dir: 1, ph: 0 });
        }
        z.bg = renderPlotBg(z);
      });

      // 5) NPC mentor near the entrance
      world.npc = { x: world.spawn.x + T * 2.2, y: (avenueY + 1) * T + T / 2, name: 'נץ', face: 'down', bob: 0 };
      world.aveBg = renderAvenueBg();
    }

    // ---- static art (cached offscreen per plot) ----------------------------
    function renderPlotBg(z) {
      var th = THEMES[z.theme] || THEMES.greenhouse;
      var W = z._pw * T, H = z._ph * T;
      var g = el('canvas'); g.width = W; g.height = H; var c = g.getContext('2d');
      for (var r = 1; r < z._ph - 1; r++) for (var col = 1; col < z._pw - 1; col++) drawGroundTile(c, col * T, r * T, th, (r + col) % 2 === 0);
      habitatGround(c, z, th, W, H);
      for (var fr = 0; fr < z._ph; fr++) for (var fc = 0; fc < z._pw; fc++) { if (fr === 0 || fc === 0 || fr === z._ph - 1 || fc === z._pw - 1) drawFenceTile(c, fc * T, fr * T, th); }
      var dLocal = z._doorC - z._px;
      var doorRow = z._above ? (z._ph - 1) : 0;
      for (var od = -1; od <= 1; od++) { c.clearRect((dLocal + od) * T, doorRow * T, T, T); drawGroundTile(c, (dLocal + od) * T, doorRow * T, th, (od) % 2 === 0); }
      z.benchObjs.forEach(function (b) { drawBenchStatic(c, b.x - z._px * T, b.y - z._py * T, b.w, th); });
      habitatOverlay(c, z, th, W, H);
      if (th.glass) drawGlassGodrays(c, W, H);
      var vg = c.createRadialGradient(W / 2, H / 2, Math.min(W, H) * 0.2, W / 2, H / 2, Math.max(W, H) * 0.72);
      vg.addColorStop(0, 'rgba(0,0,0,0)'); vg.addColorStop(1, 'rgba(40,30,10,0.10)');
      c.fillStyle = vg; c.fillRect(0, 0, W, H);
      z._bgOX = z._px * T; z._bgOY = z._py * T;
      return g;
    }
    function renderAvenueBg() {
      var W = world.wpx, H = world.AV * T;
      var g = el('canvas'); g.width = W; g.height = H; var c = g.getContext('2d');
      for (var col = 0; col < world.cols; col++) for (var r = 0; r < world.AV; r++) {
        c.fillStyle = (col % 2 === 0) ? '#d8c29a' : '#cfb78c'; c.fillRect(col * T, r * T, T, T);
        c.strokeStyle = 'rgba(120,90,50,0.18)'; c.lineWidth = 1; c.strokeRect(col * T + 1, r * T + 1, T - 2, T - 2);
      }
      c.fillStyle = 'rgba(70,140,80,0.20)'; c.fillRect(0, 0, W, 4); c.fillRect(0, H - 4, W, 4);
      return g;
    }
    function drawGroundTile(c, x, y, th, alt) {
      c.fillStyle = alt ? th.g1 : th.g2; c.fillRect(x, y, T, T);
      c.strokeStyle = th.grout; c.globalAlpha = 0.45; c.lineWidth = 1; c.strokeRect(x + 0.5, y + 0.5, T - 1, T - 1); c.globalAlpha = 1;
    }
    function drawFenceTile(c, x, y, th) {
      c.fillStyle = 'rgba(90,150,95,0.22)'; c.fillRect(x, y, T, T);
      c.fillStyle = th.fence; roundRect(c, x + 3, y + 6, T - 6, T - 12, 4); c.fill();
      c.fillStyle = 'rgba(255,255,255,0.12)'; c.fillRect(x + 4, y + 8, T - 8, 3);
      c.fillStyle = 'rgba(0,0,0,0.12)'; c.fillRect(x + 4, y + T - 12, T - 8, 3);
    }
    function drawBenchStatic(c, x, y, w, th) {
      var h = 2 * T;
      c.fillStyle = 'rgba(40,30,15,0.16)'; c.beginPath(); c.ellipse(x + w / 2, y + h - 4, w / 2 - 2, 10, 0, 0, 7); c.fill();
      c.fillStyle = shade(th.wood, -18); roundRect(c, x + 4, y + 2, w - 8, h * 0.42, 5); c.fill();
      c.fillStyle = th.wood; roundRect(c, x + 2, y + h * 0.34, w - 4, 10, 4); c.fill();
      c.fillStyle = shade(th.wood, 8); roundRect(c, x, y + h * 0.66, w, 12, 4); c.fill();
      c.strokeStyle = 'rgba(60,40,20,0.25)'; c.lineWidth = 1;
      for (var i = 1; i < 4; i++) { c.beginPath(); c.moveTo(x + i * w / 4, y + h * 0.34); c.lineTo(x + i * w / 4, y + h * 0.34 + 10); c.stroke(); }
      c.fillStyle = 'rgba(255,255,255,0.18)'; c.fillRect(x + 4, y + h * 0.34, w - 8, 2);
      c.fillStyle = shade(th.wood, -28); c.fillRect(x + 4, y + h * 0.78, 6, h * 0.2); c.fillRect(x + w - 10, y + h * 0.78, 6, h * 0.2);
    }
    function drawGlassGodrays(c, W, H) {
      c.fillStyle = 'rgba(150,220,180,0.10)'; c.fillRect(0, 0, W, H);
      c.save(); c.globalCompositeOperation = 'lighter';
      for (var i = -2; i < W / T; i += 2) {
        var gx = i * T, grad = c.createLinearGradient(gx, 0, gx + H * 0.5, H);
        grad.addColorStop(0, 'rgba(255,250,210,0.11)'); grad.addColorStop(1, 'rgba(255,250,210,0)');
        c.fillStyle = grad; c.beginPath(); c.moveTo(gx, 0); c.lineTo(gx + T * 0.9, 0); c.lineTo(gx + T * 0.9 + H * 0.5, H); c.lineTo(gx + H * 0.5, H); c.closePath(); c.fill();
      }
      c.restore();
      c.strokeStyle = 'rgba(120,150,130,0.16)'; c.lineWidth = 2;
      for (var fx = T * 2; fx < W; fx += T * 4) { c.beginPath(); c.moveTo(fx, 0); c.lineTo(fx, H); c.stroke(); }
    }
    function shade(hex, amt) {
      var n = parseInt(hex.slice(1), 16), r = clamp((n >> 16) + amt, 0, 255), g2 = clamp(((n >> 8) & 255) + amt, 0, 255), b = clamp((n & 255) + amt, 0, 255);
      return 'rgb(' + r + ',' + g2 + ',' + b + ')';
    }
    function roundRect(c, x, y, w, h, r) { c.beginPath(); c.moveTo(x + r, y); c.arcTo(x + w, y, x + w, y + h, r); c.arcTo(x + w, y + h, x, y + h, r); c.arcTo(x, y + h, x, y, r); c.arcTo(x, y, x + w, y, r); c.closePath(); }

    // ==========================================================================
    //  PLAYER (original mascot — "Sprout", a cheerful plant-sprite gardener)
    // ==========================================================================
    var player = { x: 0, y: 0, hw: 9, hh: 8, dir: 'down', moving: false, animT: 0, frame: 0 };

    function drawSprout(c, x, y, dir, frame, cos) {
      // x,y = feet anchor (bottom-centre). Drawn ~24w x 30h world px.
      var bob = player.moving ? Math.sin(frame) * 1.5 : 0;
      var legSwing = player.moving ? Math.sin(frame) * 3 : 0;
      c.save(); c.translate(x, y + bob);
      // shadow
      c.fillStyle = 'rgba(0,0,0,0.18)'; c.beginPath(); c.ellipse(0, 1, 10, 4, 0, 0, 7); c.fill();
      // legs
      c.fillStyle = '#5b3b22';
      c.fillRect(-6 + legSwing, -8, 4, 8); c.fillRect(2 - legSwing, -8, 4, 8);
      // body (green tunic / overalls)
      c.fillStyle = '#2fae6b'; roundRect(c, -9, -22, 18, 16, 6); c.fill();
      c.fillStyle = '#1f9258'; roundRect(c, -9, -12, 18, 6, 4); c.fill(); // apron band
      // arms
      c.fillStyle = '#f3c89a';
      if (dir === 'left') { c.fillRect(-12, -20, 4, 8); } else if (dir === 'right') { c.fillRect(8, -20, 4, 8); }
      else { c.fillRect(-12, -20 + Math.abs(legSwing), 4, 7); c.fillRect(8, -20 - Math.abs(legSwing), 4, 7); }
      // head
      c.fillStyle = '#f7d3a6'; c.beginPath(); c.arc(0, -27, 8, 0, 7); c.fill();
      // leaf sprout hat (cosmetic tint grows with level)
      var leaf = ['#37b56e', '#2aa75f', '#7ad08f', '#bfe36a'][cos % 4];
      c.fillStyle = '#1f7a45'; c.fillRect(-1, -38, 2, 6); // stem
      c.fillStyle = leaf;
      c.beginPath(); c.ellipse(-4, -38, 5, 3, -0.6, 0, 7); c.fill();
      c.beginPath(); c.ellipse(4, -38, 5, 3, 0.6, 0, 7); c.fill();
      // face (direction)
      c.fillStyle = '#3a2a1a';
      if (dir === 'up') { /* back of head */ }
      else if (dir === 'left') { c.beginPath(); c.arc(-3, -27, 1.4, 0, 7); c.fill(); }
      else if (dir === 'right') { c.beginPath(); c.arc(3, -27, 1.4, 0, 7); c.fill(); }
      else { c.beginPath(); c.arc(-3, -27, 1.4, 0, 7); c.arc(3, -27, 1.4, 0, 7); c.fill();
             c.strokeStyle = '#c98f5f'; c.lineWidth = 1.2; c.beginPath(); c.arc(0, -24, 2.2, 0.1, Math.PI - 0.1); c.stroke(); }
      c.restore();
    }

    // ---- dynamic art (drawn each frame in world space) ---------------------
    function getImg(p) {
      if (!p.img) return null;
      var im = imgCache[p.id];
      if (!im) { im = new Image(); im.decoding = 'async'; im.src = p.img; imgCache[p.id] = im; }
      return im;
    }
    function drawProductOnBench(c, slot, lift, glow) {
      var x = slot.x, y = slot.y - lift, s = 30 + (slot.tier === 1 ? -2 : 2);
      c.fillStyle = 'rgba(40,30,15,0.22)'; c.beginPath(); c.ellipse(slot.x, slot.y + 16, 13, 4, 0, 0, 7); c.fill();
      c.fillStyle = '#c8743f'; c.beginPath(); c.moveTo(x - 9, y + 8); c.lineTo(x + 9, y + 8); c.lineTo(x + 6, y + 18); c.lineTo(x - 6, y + 18); c.closePath(); c.fill();
      c.fillStyle = '#a85a2c'; c.fillRect(x - 10, y + 6, 20, 3);
      var img = getImg(slot.p);
      if (glow) { c.save(); c.shadowColor = 'rgba(120,220,150,0.9)'; c.shadowBlur = 12; }
      if (img && img.complete && img.naturalWidth) {
        c.save(); roundRect(c, x - s / 2, y - s + 6, s, s, 6); c.clip();
        c.drawImage(img, x - s / 2, y - s + 6, s, s); c.restore();
        c.strokeStyle = glow ? 'rgba(120,220,150,1)' : 'rgba(255,255,255,0.9)'; c.lineWidth = glow ? 2 : 1.3;
        roundRect(c, x - s / 2, y - s + 6, s, s, 6); c.stroke();
      } else {
        c.font = '26px serif'; c.textAlign = 'center'; c.textBaseline = 'alphabetic'; c.fillText('🪴', x, y + 6);
      }
      if (glow) c.restore();
    }
    function drawTreasure(c, x, y, t) {
      c.save(); c.translate(x, y + Math.sin(t * 2) * 2);
      c.font = '24px serif'; c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillText('🎁', 0, 0);
      c.restore();
    }
    function drawStationNew(c, x, y, type) {
      c.fillStyle = 'rgba(40,30,15,0.18)'; c.beginPath(); c.ellipse(x, y + 16, 18, 6, 0, 0, 7); c.fill();
      c.fillStyle = '#9a6a3a'; roundRect(c, x - 17, y - 4, 34, 16, 4); c.fill();
      c.fillStyle = '#7c5530'; c.fillRect(x - 16, y + 10, 4, 9); c.fillRect(x + 12, y + 10, 4, 9);
      c.font = '22px serif'; c.textAlign = 'center'; c.textBaseline = 'middle'; c.fillText(MG_EMOJI[type] || '🎮', x, y - 10);
    }
    function drawDeco(c, d, t) {
      c.save(); c.translate(d.x, d.y); c.rotate(Math.sin(t * 1.2 + d.sway) * 0.06);
      c.font = '30px serif'; c.textAlign = 'center'; c.textBaseline = 'alphabetic'; c.fillText(d.emoji, 0, 6);
      c.restore();
    }
    function drawNpc(c, npc, t) {
      var x = npc.x, y = npc.y, bob = Math.sin(t * 1.6) * 1.5;
      c.save(); c.translate(x, y + bob);
      c.fillStyle = 'rgba(0,0,0,0.18)'; c.beginPath(); c.ellipse(0, 12, 11, 4, 0, 0, 7); c.fill();
      c.fillStyle = '#3f7d52'; roundRect(c, -11, -14, 22, 26, 8); c.fill();
      c.fillStyle = '#2f6340'; roundRect(c, -11, 0, 22, 12, 6); c.fill();
      c.fillStyle = '#cfe8c6'; c.beginPath(); c.arc(0, -20, 9, 0, 7); c.fill();
      c.fillStyle = '#2aa75f'; c.beginPath(); c.ellipse(0, -30, 13, 6, 0, 0, 7); c.fill();
      c.fillStyle = '#1f7a45'; c.fillRect(-1, -34, 2, 5);
      c.fillStyle = '#2a3a2a'; c.beginPath(); c.arc(-3, -20, 1.3, 0, 7); c.arc(3, -20, 1.3, 0, 7); c.fill();
      c.fillStyle = '#e7e7e7'; c.fillRect(-5, -14, 10, 4);
      c.restore();
      if (npc.marker) bubble(c, x, y - 42, npc.marker);
    }
    function drawSign(c, x, y, txt, accent) {
      c.save();
      c.fillStyle = '#8a6f4d'; c.fillRect(x - 2, y - 2, 4, 16);
      c.fillStyle = accent || '#caa56a'; roundRect(c, x - 32, y - 24, 64, 19, 4); c.fill();
      c.strokeStyle = 'rgba(60,40,20,0.4)'; c.lineWidth = 1; roundRect(c, x - 32, y - 24, 64, 19, 4); c.stroke();
      c.fillStyle = '#3a2a16'; c.font = 'bold 10px Heebo, sans-serif'; c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillText(txt, x, y - 14, 60);
      c.restore();
    }
    function bubble(c, x, y, txt) {
      c.font = 'bold 16px serif'; c.textAlign = 'center'; c.textBaseline = 'middle';
      c.fillStyle = '#fff'; c.strokeStyle = 'rgba(0,0,0,0.15)';
      c.beginPath(); c.arc(x, y, 10, 0, 7); c.fill(); c.stroke();
      c.fillStyle = '#e0532a'; c.fillText(txt, x, y + 1);
    }

    // ==========================================================================
    //  RENDER LOOP + CAMERA
    // ==========================================================================
    var running = false, rafId = 0, lastT = 0, paused = false, gt = 0;
    var zone = null;                 // current region (by player position)
    var camTarget = { x: 0, y: 0 };
    var cinematic = null;            // intro camera pan state

    function resize() {
      var rect = frame.getBoundingClientRect();
      viewW = Math.max(280, rect.width); viewH = Math.max(280, rect.height);
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(viewW * DPR); canvas.height = Math.round(viewH * DPR);
      canvas.style.width = viewW + 'px'; canvas.style.height = viewH + 'px';
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      computeScale();
      if (!running && world.solid) { camCenter(player.x, player.y); updateCamera(0, true); draw(); }
    }
    function computeScale() {
      var tilesY = viewW < 520 ? 8.5 : 10;
      scale = clamp(viewH / (tilesY * T), 0.7, 2.6);
    }
    function camCenter(cx, cy) {
      var visW = viewW / scale, visH = viewH / scale;
      camTarget.x = clamp(cx - visW / 2, 0, Math.max(0, world.wpx - visW));
      camTarget.y = clamp(cy - visH / 2, 0, Math.max(0, world.hpx - visH));
    }
    function updateCamera(dt, snap) {
      var visW = viewW / scale, visH = viewH / scale;
      ox = 0; oy = 0;
      if (world.wpx <= visW) ox = (viewW - world.wpx * scale) / 2;
      if (world.hpx <= visH) oy = (viewH - world.hpx * scale) / 2;
      var k = snap ? 1 : Math.min(1, dt * 6);
      cam.x += (camTarget.x - cam.x) * k; cam.y += (camTarget.y - cam.y) * k;
    }

    function loop(ts) {
      if (!running) return;
      rafId = requestAnimationFrame(loop);
      var dt = Math.min(0.05, (ts - lastT) / 1000 || 0); lastT = ts; gt += dt;
      if (cinematic) updateCinematic(dt);
      else if (!paused) { update(dt); S.playMs += dt * 1000; }
      updateCamera(dt, false);
      draw();
    }
    function startLoop() { if (running) return; running = true; lastT = performance.now(); rafId = requestAnimationFrame(loop); }
    function stopLoop() { running = false; if (rafId) cancelAnimationFrame(rafId); }

    function visBounds() {
      var visW = viewW / scale, visH = viewH / scale;
      return { x0: cam.x - T, y0: cam.y - T, x1: cam.x + visW + T, y1: cam.y + visH + T };
    }

    function draw() {
      var bgGrad = ctx.createLinearGradient(0, 0, 0, viewH);
      bgGrad.addColorStop(0, '#cfe9d4'); bgGrad.addColorStop(1, '#bfe1c6');
      ctx.fillStyle = bgGrad; ctx.fillRect(0, 0, viewW, viewH);
      if (!world.solid) return;
      ctx.save();
      ctx.translate(ox, oy); ctx.scale(scale, scale); ctx.translate(-cam.x, -cam.y);
      var vb = visBounds();
      if (world.aveBg) ctx.drawImage(world.aveBg, 0, world.avenueY * T);
      zones.forEach(function (z) {
        if (z._bgOX + z._pw * T < vb.x0 || z._bgOX > vb.x1 || z._bgOY + z._ph * T < vb.y0 || z._bgOY > vb.y1) return;
        ctx.drawImage(z.bg, z._bgOX, z._bgOY);
        drawSign(ctx, z.doorPx.x, z.doorPx.y + (z._above ? 18 : 24), z.name || '', (THEMES[z.theme] || {}).accent);
        if (z.station) { drawStationNew(ctx, z.station.cx, z.station.cy, z.station.type); if (nearest && nearest.kind === 'station' && nearest.z === z) bubble(ctx, z.station.cx, z.station.cy - 26, '★'); }
        z.decoObjs.forEach(function (d) { drawDeco(ctx, d, gt); });
        z.treasures.forEach(function (tr) { if (!S.treasureIds[tr.key]) drawTreasure(ctx, tr.cx, tr.cy, gt); });
        drawCreatures(ctx, z, gt);
        z.benchObjs.forEach(function (b) {
          b.slots.forEach(function (slot) {
            var isNear = nearest && nearest.kind === 'product' && nearest.ref === slot;
            slot._lift = (slot._lift || 0) + (((isNear ? 7 : 0) - (slot._lift || 0)) * 0.2);
            drawProductOnBench(ctx, slot, slot._lift, isNear);
            if (isNear) bubble(ctx, slot.x, slot.y - 34 - slot._lift, '+');
          });
        });
      });
      if (world.npc) drawNpc(ctx, world.npc, gt);
      drawSprout(ctx, player.x, player.y + player.hh, player.dir, player.frame, S.cosmetic);
      drawObjectiveArrow(ctx);
      drawAmbient(ctx, gt);
      ctx.restore();
      drawMinimap();
    }

    // ==========================================================================
    //  INPUT + MOVEMENT
    // ==========================================================================
    var keys = {}, dpad = { x: 0, y: 0 }, moveTarget = null;
    var SPEED = 3.2 * T;

    function isSolidPx(px, py) {
      var c = Math.floor(px / T), r = Math.floor(py / T);
      if (r < 0 || c < 0 || r >= world.rows || c >= world.cols) return true;
      return world.solid[r][c];
    }
    function canBe(cx, cy) {
      var hw = player.hw, hh = player.hh;
      return !(isSolidPx(cx - hw, cy - hh) || isSolidPx(cx + hw, cy - hh) || isSolidPx(cx - hw, cy + hh) || isSolidPx(cx + hw, cy + hh));
    }

    var nearest = null;

    function update(dt) {
      var ix = 0, iy = 0;
      if (keys.left) ix -= 1; if (keys.right) ix += 1; if (keys.up) iy -= 1; if (keys.down) iy += 1;
      ix += dpad.x; iy += dpad.y;
      if (ix || iy) moveTarget = null;
      else if (moveTarget) {
        var dx = moveTarget.x - player.x, dy = moveTarget.y - player.y, d = Math.hypot(dx, dy);
        if (d < 7) moveTarget = null; else { ix = dx / d; iy = dy / d; }
      }
      var len = Math.hypot(ix, iy);
      player.moving = len > 0.01;
      if (player.moving) {
        ix /= len; iy /= len;
        if (Math.abs(ix) > Math.abs(iy)) player.dir = ix < 0 ? 'left' : 'right'; else player.dir = iy < 0 ? 'up' : 'down';
        var nx = player.x + ix * SPEED * dt, ny = player.y + iy * SPEED * dt;
        if (canBe(nx, player.y)) player.x = nx; else moveTarget = null;
        if (canBe(player.x, ny)) player.y = ny; else moveTarget = null;
        player.animT += dt; player.frame = player.animT * 9;
        player._step = (player._step || 0) + dt; if (player._step > 0.34) { player._step = 0; Audio2.sfx('step'); }
      }
      camCenter(player.x, player.y);
      var rz = regionAt(player.x, player.y);
      if (rz && rz !== zone) setZone(rz);
      computeNearest();
      if (world.npc) world.npc.marker = (!S.npcDone || (questGetTarget() === world.npc)) && nearTo(world.npc, T * 3) ? '💬' : '';
      zones.forEach(function (z) { z.treasures.forEach(function (tr) { if (!S.treasureIds[tr.key] && Math.hypot(player.x - tr.cx, player.y - tr.cy) < T * 0.85) collectTreasure(tr); }); });
      if (world.npc && !S.npcDone && nearTo(world.npc, T * 1.2) && layers.length === 0) talkNpc();
      if (nearest && nearest.kind === 'product') { if (!card || card._pid !== nearest.ref.p.id) openCard(nearest.ref.p, nearest.ref); }
      else if (card && card._auto) { closeCard(); }
      setActionHot(!!nearest || (world.npc && nearTo(world.npc, T * 1.4)));
      updateAmbient(dt); updateCreatures(dt);
    }

    function nearTo(o, rad) { return Math.hypot(player.x - o.x, player.y - o.y) < rad; }

    function regionAt(px, py) {
      var tx = px / T, ty = py / T;
      for (var i = 0; i < zones.length; i++) {
        var b = zones[i].bounds;
        if (tx >= b.px && tx <= b.px + b.pw && ty >= b.py && ty <= b.py + b.ph) return zones[i];
      }
      return null;
    }
    function setZone(z) {
      zone = z;
      if (!S.zonesVisited[z._i]) { S.zonesVisited[z._i] = true; addXp(2); questEvent('visit', z); }
      Audio2.setAmbient(z.ambient);
      updateHud(); save();
      toast((ZONE_EMOJI[z.theme] || '🌿') + ' ' + (z.name || '')); say(t('zone_enter', { x: z.name }));
      fire('zone_enter', { zone: z.name, handle: z.handle, index: z._i });
      checkRewards();
    }

    function computeNearest() {
      nearest = null; var best = 1e9;
      zones.forEach(function (z) {
        var b = z.bounds;
        if (player.x < (b.px - 2) * T || player.x > (b.px + b.pw + 2) * T || player.y < (b.py - 2) * T || player.y > (b.py + b.ph + 2) * T) return;
        z.benchObjs.forEach(function (bn) {
          bn.slots.forEach(function (slot) {
            var dd = Math.hypot(player.x - slot.x, player.y - (slot.y + 10));
            if (dd < T * 1.4 && dd < best) { best = dd; nearest = { kind: 'product', ref: slot, z: z }; }
          });
        });
        if (z.station) { var ds = Math.hypot(player.x - z.station.cx, player.y - z.station.cy); if (ds < T * 1.5 && ds < best) { best = ds; nearest = { kind: 'station', ref: z.station, z: z }; } }
      });
    }

    function doAction() {
      Audio2.ensure();
      if (world.npc && nearTo(world.npc, T * 1.4)) { talkNpc(); return; }
      if (card && nearest && nearest.kind === 'product') { Cart.add(nearest.ref.p); return; }
      if (nearest && nearest.kind === 'station') { openMinigame(nearest.ref.type); return; }
      if (nearest && nearest.kind === 'product') { openCard(nearest.ref.p, nearest.ref); return; }
    }

    on(window, 'keydown', function (e) {
      if (!started) return;
      var k = e.key.toLowerCase();
      if (k === 'arrowleft' || k === 'a') keys.left = 1; else if (k === 'arrowright' || k === 'd') keys.right = 1;
      else if (k === 'arrowup' || k === 'w') keys.up = 1; else if (k === 'arrowdown' || k === 's') keys.down = 1;
      else if (k === ' ' || k === 'enter') { if (dialogActive) { e.preventDefault(); dialogActive.__next(); } else if (cinematic) skipCinematic(); else if (layers.length === 0) { e.preventDefault(); doAction(); } return; }
      else if (k === 'escape') { if (layers.length) closeTopLayer(); else if (card) closeCard(); return; }
      else if (k === 'm') { toggleMute(); return; }
      else return;
      if (document.activeElement === canvas || frame.contains(document.activeElement) || document.activeElement === document.body) e.preventDefault();
    });
    on(window, 'keyup', function (e) {
      var k = e.key.toLowerCase();
      if (k === 'arrowleft' || k === 'a') keys.left = 0; else if (k === 'arrowright' || k === 'd') keys.right = 0;
      else if (k === 'arrowup' || k === 'w') keys.up = 0; else if (k === 'arrowdown' || k === 's') keys.down = 0;
    });

    var tapStart = null;
    on(canvas, 'pointerdown', function (e) { tapStart = { x: e.clientX, y: e.clientY, t: Date.now() }; });
    on(canvas, 'pointerup', function (e) {
      if (!started || !tapStart) return;
      if (cinematic) { skipCinematic(); tapStart = null; return; }
      if (paused) { tapStart = null; return; }
      var moved = Math.hypot(e.clientX - tapStart.x, e.clientY - tapStart.y);
      var rect = canvas.getBoundingClientRect();
      var wx = (e.clientX - rect.left - ox) / scale + cam.x, wy = (e.clientY - rect.top - oy) / scale + cam.y;
      tapStart = null;
      var hit = hitTest(wx, wy);
      if (hit) {
        var hx = hit.kind === 'npc' ? world.npc.x : (hit.kind === 'product' ? hit.ref.x : hit.ref.cx);
        var hy = hit.kind === 'npc' ? world.npc.y : (hit.kind === 'product' ? hit.ref.y : hit.ref.cy);
        if (Math.hypot(player.x - hx, player.y - hy) < T * 1.7) {
          if (hit.kind === 'product') openCard(hit.ref.p, hit.ref); else if (hit.kind === 'station') openMinigame(hit.ref.type); else if (hit.kind === 'npc') talkNpc();
        } else { moveTarget = { x: hx, y: hy + (hit.kind === 'product' ? 18 : 0) }; }
        return;
      }
      if (moved < 40) moveTarget = { x: wx, y: wy };
    });
    function hitTest(wx, wy) {
      var hit = null, best = 1e9;
      zones.forEach(function (z) {
        z.benchObjs.forEach(function (bn) { bn.slots.forEach(function (slot) { var d = Math.hypot(wx - slot.x, wy - slot.y); if (d < 24 && d < best) { best = d; hit = { kind: 'product', ref: slot }; } }); });
        if (z.station) { var ds = Math.hypot(wx - z.station.cx, wy - z.station.cy); if (ds < 24 && ds < best) { best = ds; hit = { kind: 'station', ref: z.station }; } }
      });
      if (world.npc) { var dn = Math.hypot(wx - world.npc.x, wy - world.npc.y); if (dn < 26 && dn < best) { best = dn; hit = { kind: 'npc' }; } }
      return hit;
    }

    // ==========================================================================
    //  AMBIENT PARTICLES
    // ==========================================================================
    var parts = [];
    function updateAmbient(dt) {
      if (S.reduced) { parts.length = 0; return; }
      var kind = zone ? zone.ambient : 'none';
      var want = (!kind || kind === 'none') ? 0 : (viewW < 520 ? 7 : 13);
      while (parts.length < want) parts.push(spawnPart(kind));
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i]; p.life -= dt; p.x += p.vx * dt; p.y += p.vy * dt; p.ph += dt;
        if (p.kind === 'butterfly' || p.kind === 'bee') { p.x += Math.sin(p.ph * 4) * 14 * dt; p.y += Math.cos(p.ph * 3) * 10 * dt; }
        if (p.life <= 0 || p.kind !== kind) parts.splice(i, 1);
      }
    }
    function spawnPart(kind) {
      var vb = visBounds(), x = vb.x0 + Math.random() * (vb.x1 - vb.x0), y = vb.y0 + Math.random() * (vb.y1 - vb.y0);
      if (kind === 'drips') return { kind: kind, x: x, y: vb.y0 + Math.random() * 30, vx: 0, vy: 60 + Math.random() * 40, life: 2 + Math.random() * 2, ph: 0 };
      if (kind === 'heat') return { kind: kind, x: x, y: y, vx: 0, vy: -8, life: 2 + Math.random() * 2, ph: Math.random() * 6 };
      if (kind === 'fireflies') return { kind: kind, x: x, y: y, vx: (Math.random() - .5) * 10, vy: (Math.random() - .5) * 10, life: 3 + Math.random() * 3, ph: Math.random() * 6 };
      return { kind: kind, x: x, y: y, vx: (Math.random() - .5) * 18, vy: (Math.random() - .5) * 12, life: 4 + Math.random() * 4, ph: Math.random() * 6 };
    }
    function drawAmbient(c, t) {
      c.textAlign = 'center'; c.textBaseline = 'middle';
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i]; c.globalAlpha = clamp(p.life, 0, 1);
        if (p.kind === 'butterfly') { c.font = '15px serif'; c.fillText('🦋', p.x, p.y); }
        else if (p.kind === 'bee') { c.font = '12px serif'; c.fillText('🐝', p.x, p.y); }
        else if (p.kind === 'fireflies') { c.fillStyle = 'rgba(255,240,150,' + (0.4 + 0.6 * Math.abs(Math.sin(p.ph * 3))) + ')'; c.beginPath(); c.arc(p.x, p.y, 2.5, 0, 7); c.fill(); }
        else if (p.kind === 'drips') { c.fillStyle = 'rgba(120,180,210,0.7)'; c.beginPath(); c.ellipse(p.x, p.y, 1.6, 3.4, 0, 0, 7); c.fill(); }
        else if (p.kind === 'heat') { c.fillStyle = 'rgba(255,210,140,0.16)'; c.beginPath(); c.arc(p.x, p.y, 6 + Math.sin(p.ph * 4) * 2, 0, 7); c.fill(); }
        else { c.fillStyle = 'rgba(255,250,200,0.7)'; c.beginPath(); c.arc(p.x, p.y, 1.8, 0, 7); c.fill(); }
      }
      c.globalAlpha = 1;
    }

    // ==========================================================================
    //  BESPOKE HABITAT ART + CREATURES
    // ==========================================================================
    function habitatGround(c, z, th, W, H) {
      var ix0 = T, iy0 = T, iw = W - 2 * T, ih = H - 2 * T, rng = rand(z._i * 71 + 3);
      if (z.theme === 'desert') {
        for (var d = 0; d < 4; d++) {
          c.fillStyle = 'rgba(205,165,95,' + (0.10 + d * 0.02) + ')';
          var yy = iy0 + ih * (0.18 + d * 0.21); c.beginPath(); c.moveTo(ix0, yy);
          for (var x = ix0; x <= ix0 + iw; x += 12) c.lineTo(x, yy + Math.sin(x * 0.05 + d) * 6);
          c.lineTo(ix0 + iw, yy + 20); c.lineTo(ix0, yy + 20); c.closePath(); c.fill();
        }
        c.fillStyle = '#c2b08c';
        for (var rk = 0; rk < 4; rk++) { var rx = ix0 + rng() * iw, ry = iy0 + rng() * ih; c.beginPath(); c.ellipse(rx, ry, 7 + rng() * 5, 5 + rng() * 3, 0, 0, 7); c.fill(); c.fillStyle = 'rgba(0,0,0,0.08)'; c.beginPath(); c.ellipse(rx, ry + 4, 8, 3, 0, 0, 7); c.fill(); c.fillStyle = '#c2b08c'; }
      } else if (z.theme === 'tropical') {
        c.fillStyle = 'rgba(28,95,58,0.12)';
        for (var i = 0; i < 9; i++) { c.beginPath(); c.arc(ix0 + rng() * iw, iy0 + rng() * ih, 13 + rng() * 16, 0, 7); c.fill(); }
        if (z.pond) {
          var px = z.pond.x - z._px * T, py = z.pond.y - z._py * T, pw = z.pond.w, ph = z.pond.h;
          c.fillStyle = 'rgba(30,90,70,0.5)'; roundRect(c, px - 5, py - 5, pw + 10, ph + 10, 18); c.fill();
          c.fillStyle = '#3f7d8f'; roundRect(c, px, py, pw, ph, 14); c.fill();
          c.fillStyle = 'rgba(150,210,215,0.5)'; roundRect(c, px + 5, py + 5, pw - 10, ph * 0.4, 9); c.fill();
        }
      } else if (z.theme === 'sun') {
        var sg = c.createRadialGradient(W * 0.5, iy0 + 8, 8, W * 0.5, iy0 + 8, iw * 0.75);
        sg.addColorStop(0, 'rgba(255,240,165,0.38)'); sg.addColorStop(1, 'rgba(255,240,165,0)');
        c.fillStyle = sg; c.fillRect(ix0, iy0, iw, ih);
      } else if (z.theme === 'gifts') { c.fillStyle = 'rgba(225,150,205,0.08)'; c.fillRect(ix0, iy0, iw, ih); }
    }
    function habitatOverlay(c, z, th, W, H) {
      if (z.theme === 'tropical') {
        drawCanopy(c, W - T - 26, T + 2);
        for (var y = T + 10; y < H - T; y += 36) drawMonsteraLeaf(c, W - T - 4, y);
        var mg = c.createLinearGradient(0, 0, 0, H); mg.addColorStop(0, 'rgba(220,240,232,0.20)'); mg.addColorStop(0.5, 'rgba(220,240,232,0.05)'); mg.addColorStop(1, 'rgba(220,240,232,0.12)');
        c.fillStyle = mg; c.fillRect(0, 0, W, H);
      } else if (z.theme === 'climbers') { drawTrellis(c, T, T - 4, W - 2 * T, 22); }
      else if (z.theme === 'gifts') { drawStringLights(c, T, T + 6, W - 2 * T); }
      else if (z.theme === 'sun') { for (var sx = T + 22; sx < W - T; sx += 48) drawSunflower(c, sx, H - T - 6); }
    }
    function drawCanopy(c, x, y) {
      c.fillStyle = '#6b4a2c'; c.fillRect(x - 5, y + 10, 10, 70);
      c.fillStyle = '#2f7d4a'; [[0, 0, 34], [-22, -4, 24], [22, -2, 26], [0, -22, 26]].forEach(function (b) { c.beginPath(); c.arc(x + b[0], y + b[1], b[2], 0, 7); c.fill(); });
      c.fillStyle = '#3f9d5a'; [[-10, -8, 16], [12, -6, 16]].forEach(function (b) { c.beginPath(); c.arc(x + b[0], y + b[1], b[2], 0, 7); c.fill(); });
    }
    function drawMonsteraLeaf(c, x, y) {
      c.save(); c.translate(x, y); c.fillStyle = '#2f8f54';
      c.beginPath(); c.ellipse(0, 0, 11, 8, -0.5, 0, 7); c.fill();
      c.fillStyle = 'rgba(40,90,55,0.55)'; for (var i = -1; i <= 1; i++) { c.beginPath(); c.ellipse(i * 4, 1, 1.4, 4, -0.5, 0, 7); c.fill(); }
      c.restore();
    }
    function drawTrellis(c, x, y, w, h) {
      c.strokeStyle = 'rgba(150,110,60,0.7)'; c.lineWidth = 3;
      for (var gx = x; gx <= x + w; gx += 18) { c.beginPath(); c.moveTo(gx, y); c.lineTo(gx, y + h); c.stroke(); }
      for (var gy = y; gy <= y + h; gy += 11) { c.beginPath(); c.moveTo(x, gy); c.lineTo(x + w, gy); c.stroke(); }
      c.fillStyle = '#3f9d5a'; for (var lx = x + 6; lx < x + w; lx += 26) { c.beginPath(); c.ellipse(lx, y + h - 4, 5, 3, 0.6, 0, 7); c.fill(); }
    }
    function drawStringLights(c, x, y, w) {
      c.strokeStyle = 'rgba(80,60,40,0.6)'; c.lineWidth = 1.5; c.beginPath();
      for (var sx = x; sx <= x + w; sx += 6) c.lineTo(sx, y + Math.sin(sx * 0.06) * 6); c.stroke();
      var cols = ['#e0532a', '#f3b73d', '#22b572', '#3b82f6', '#9b59b6'];
      for (var bx = x + 14, i = 0; bx < x + w; bx += 28, i++) { c.fillStyle = cols[i % cols.length]; c.beginPath(); c.arc(bx, y + Math.sin(bx * 0.06) * 6 + 5, 3.5, 0, 7); c.fill(); }
    }
    function drawSunflower(c, x, y) {
      c.strokeStyle = '#4a7a30'; c.lineWidth = 3; c.beginPath(); c.moveTo(x, y); c.lineTo(x, y - 26); c.stroke();
      c.fillStyle = '#f3c01f'; for (var a = 0; a < 6.28; a += 0.5) { c.beginPath(); c.ellipse(x + Math.cos(a) * 9, y - 26 + Math.sin(a) * 9, 4, 2.4, a, 0, 7); c.fill(); }
      c.fillStyle = '#7a4a1e'; c.beginPath(); c.arc(x, y - 26, 5.5, 0, 7); c.fill();
    }
    function updateCreatures(dt) {
      zones.forEach(function (z) {
        if (!z.creatures || !z.creatures.length) return;
        var b = z.bounds; if (player.x < (b.px - 3) * T || player.x > (b.px + b.pw + 3) * T) return;
        z.creatures.forEach(function (cr) {
          if (cr.kind === 'tortoise') { cr.ph += dt; cr.x += cr.dir * 7 * dt; if (cr.x < (b.x0 + 1) * T) cr.dir = 1; else if (cr.x > (b.x1 - 1) * T) cr.dir = -1; cr.y = z.cy + Math.sin(cr.ph * 0.5) * T * 0.8; }
          else if (cr.kind === 'koi') cr.a += cr.sp * dt;
        });
      });
    }
    function drawCreatures(c, z, t) {
      if (!z.creatures) return;
      z.creatures.forEach(function (cr) {
        if (cr.kind === 'tortoise') drawTortoise(c, cr.x, cr.y, cr.dir);
        else if (cr.kind === 'koi' && z.pond) drawKoi(c, z.pond.cx + Math.cos(cr.a) * cr.r, z.pond.cy + Math.sin(cr.a) * cr.r * 0.65, cr.a, cr.col);
      });
    }
    function drawTortoise(c, x, y, dir) {
      c.save(); c.translate(x, y); c.scale(dir, 1);
      c.fillStyle = 'rgba(0,0,0,0.16)'; c.beginPath(); c.ellipse(0, 9, 14, 4, 0, 0, 7); c.fill();
      c.fillStyle = '#6b8e4e'; c.fillRect(9, -2, 8, 5);
      c.fillStyle = '#5a7a3e'; c.fillRect(-11, 5, 5, 5); c.fillRect(6, 5, 5, 5);
      c.fillStyle = '#8a6238'; c.beginPath(); c.ellipse(0, 0, 13, 9, 0, 0, 7); c.fill();
      c.strokeStyle = '#5a3f28'; c.lineWidth = 1; for (var i = -1; i <= 1; i++) { c.beginPath(); c.moveTo(i * 6, -8); c.lineTo(i * 6, 8); c.stroke(); }
      c.restore();
    }
    function drawKoi(c, x, y, a, col) {
      c.save(); c.translate(x, y); c.rotate(a + Math.PI / 2);
      c.fillStyle = col; c.beginPath(); c.ellipse(0, 0, 5, 9, 0, 0, 7); c.fill();
      c.beginPath(); c.moveTo(0, 8); c.lineTo(-4, 14); c.lineTo(4, 14); c.closePath(); c.fill();
      c.restore();
    }

    // ==========================================================================
    //  CINEMATIC INTRO (walk-in + camera reveal)
    // ==========================================================================
    function startIntro(done) {
      cinematic = { t: 0, done: done, wi: 0, hold: 0, way: [] };
      var lb = el('div', 'dga-letterbox'); overlays.appendChild(lb); cinematic.lb = lb;
      var sk = el('button', 'dga-cine-skip', t('skip_intro')); overlays.appendChild(sk); cinematic.skip = sk;
      on(sk, 'click', skipCinematic);
      player.x = world.entrance.x; player.y = world.entrance.y; player.dir = 'right'; player.moving = true;
      cinematic.way.push({ x: world.spawn.x + T * 3, y: (world.avenueY + 1.5) * T, hold: 0.5 });
      for (var i = 0; i < Math.min(zones.length, 6); i++) cinematic.way.push({ x: zones[i].cx, y: zones[i].cy, hold: 0.45 });
      cinematic.way.push({ x: world.npc.x, y: world.npc.y, hold: 0.4 });
      camCenter(cinematic.way[0].x, cinematic.way[0].y); updateCamera(0, true);
      Audio2.setAmbient('butterflies'); say(t('intro_say'));
    }
    function updateCinematic(dt) {
      var ci = cinematic; ci.t += dt;
      if (player.x < world.spawn.x + T * 1.2 && canBe(player.x + SPEED * 0.55 * dt, player.y)) { player.x += SPEED * 0.55 * dt; player.animT += dt; player.frame = player.animT * 9; }
      var w = ci.way[ci.wi]; camCenter(w.x, w.y);
      if (Math.abs(camTarget.x - cam.x) < 8 && Math.abs(camTarget.y - cam.y) < 8) {
        ci.hold += dt; if (ci.hold > w.hold) { ci.hold = 0; ci.wi++; if (ci.wi >= ci.way.length) skipCinematic(); }
      }
    }
    function skipCinematic() {
      if (!cinematic) return; var d = cinematic.done;
      if (cinematic.lb) cinematic.lb.remove(); if (cinematic.skip) cinematic.skip.remove(); cinematic = null;
      player.x = world.spawn.x; player.y = world.spawn.y; player.dir = 'up'; player.moving = false;
      camCenter(player.x, player.y); updateCamera(0, true);
      if (d) d();
    }

    // ==========================================================================
    //  NPC DIALOG (mentor "נץ")
    // ==========================================================================
    var dialogActive = null;
    function dialog(lines, onDone) {
      if (dialogActive) dialogActive.remove();
      var i = 0, box = el('div', 'dga-dialog');
      box.innerHTML = '<div class="dga-dialog__face">🌿</div><div class="dga-dialog__body"><b class="dga-dialog__name">נץ · שומר הגן</b><p class="dga-dialog__txt"></p><span class="dga-dialog__more">המשך ▾</span></div>';
      var txt = box.querySelector('.dga-dialog__txt');
      overlays.appendChild(box); dialogActive = box; paused = true;
      function show() { txt.textContent = lines[i]; }
      box.__next = function () { i++; if (i >= lines.length) { box.remove(); dialogActive = null; paused = (layers.length > 0); Audio2.sfx('pickup'); if (onDone) onDone(); } else { show(); Audio2.sfx('step'); } };
      on(box, 'click', box.__next); show();
      return box;
    }
    function talkNpc() {
      if (dialogActive) { dialogActive.__next(); return; }
      if (!S.npcDone) {
        dialog([
          'ברוך הבא למשתלה הקסומה של דקו גרדן! 🌿 אני נץ, שומר הגן.',
          'כאן כל צמח חי בעולם הטבעי שלו — ג׳ונגל טרופי לוחש, מדבר חמים, וגינה שטופת שמש.',
          'המשתלה מתעוררת לאביב — תעזור לי? קבל את משימת הגנן:',
          '① סייר בכל האזורים · ② עזור ל-3 צמחים · ③ מלא את העגלה שלך. בהצלחה! 🌱'
        ], function () { S.npcDone = true; startQuest(); save(); });
      } else if (questAllDone() && !S.finaleDone) {
        S.finaleDone = true; save();
        dialog(['עשית את זה, גנן! 🌸 כל המשתלה פורחת מחדש בזכותך.', 'קבל את מתנת הסיום שלי — ותודה מכל הצמחים. 🌿'], function () { S.finished = true; burstConfetti(90); checkRewards(); endGame(); });
      } else { dialog([questHintText()], null); }
    }

    // ==========================================================================
    //  QUEST
    // ==========================================================================
    function startQuest() { if (!S.quest) S.quest = { helped: 0 }; questUpdateHud(); toast('📜 ' + t('quest_started'), 'gold'); save(); }
    function questEvent() { questUpdateHud(); }
    function questHelpedPlant() { if (!S.quest) S.quest = { helped: 0 }; S.quest.helped = (S.quest.helped || 0) + 1; questUpdateHud(); save(); if (questAllDone()) toast('✅ ' + t('quest_ready'), 'gold'); }
    function questProgress() {
      var visited = count(S.zonesVisited), helped = (S.quest && S.quest.helped) || 0, met = cfg.threshold > 0 && Cart.sub >= cfg.threshold * 100;
      return { visited: visited, totalZones: zones.length, visitDone: visited >= zones.length, helped: helped, helpDone: helped >= 3, cartDone: met };
    }
    function questAllDone() { var q = questProgress(); return S.npcDone && q.visitDone && q.helpDone && q.cartDone; }
    function questGetTarget() {
      if (!S.npcDone) return world.npc;
      var q = questProgress();
      if (!q.visitDone) { for (var i = 0; i < zones.length; i++) if (!S.zonesVisited[i]) return zones[i]; }
      if (!q.helpDone) { for (var j = 0; j < zones.length; j++) if (zones[j].station && !S.mgCleared[zones[j].minigame]) return zones[j].station; }
      if (questAllDone()) return world.npc;
      return null;
    }
    function questHintText() {
      var q = questProgress();
      if (!S.npcDone) return t('quest_meet_npc');
      if (!q.visitDone) return t('quest_visit', { x: q.totalZones - q.visited });
      if (!q.helpDone) return t('quest_help', { x: 3 - q.helped });
      if (!q.cartDone) return t('quest_cart');
      return t('quest_done_hint');
    }
    function questUpdateHud() { if (hud && hud.questline) hud.questline.textContent = '🎯 ' + questHintText(); }
    function openQuestLog() {
      var q = questProgress(); var b = el('div', 'dga-quest');
      function row(done, label) { return '<div class="dga-quest__row ' + (done ? 'is-done' : '') + '"><span>' + (done ? '✅' : '⬜') + '</span> ' + label + '</div>'; }
      b.innerHTML = '<p class="dga-quest__intro">' + t('quest_title_text') + '</p>' +
        row(S.npcDone, t('quest_q_meet')) +
        row(q.visitDone, t('quest_q_visit', { a: q.visited, b: q.totalZones })) +
        row(q.helpDone, t('quest_q_help', { a: q.helped })) +
        row(q.cartDone, t('quest_q_cart'));
      modal({ title: '📜 ' + t('quest'), body: b });
    }

    // ---- objective arrow (in-world) + mini-map -----------------------------
    function drawObjectiveArrow(c) {
      if (cinematic) return; var tgt = questGetTarget(); if (!tgt) return;
      var tx = tgt.x != null ? tgt.x : tgt.cx, ty = tgt.y != null ? tgt.y : tgt.cy;
      if (Math.hypot(tx - player.x, ty - player.y) < T * 2.2) return;
      var ang = Math.atan2(ty - player.y, tx - player.x), bob = Math.sin(gt * 4) * 2;
      c.save(); c.translate(player.x, player.y - 48 - bob); c.rotate(ang);
      c.fillStyle = 'rgba(240,180,50,0.96)'; c.strokeStyle = 'rgba(120,80,10,0.5)'; c.lineWidth = 1;
      c.beginPath(); c.moveTo(15, 0); c.lineTo(1, -8); c.lineTo(5, 0); c.lineTo(1, 8); c.closePath(); c.fill(); c.stroke();
      c.restore();
    }
    function drawMinimap() {
      if (!hud || !hud.mini) return;
      var mc = hud.mini, c = mc.getContext('2d'), W = mc.width, H = mc.height;
      var sx = W / world.wpx, sy = H / world.hpx, s = Math.min(sx, sy), oX = (W - world.wpx * s) / 2, oY = (H - world.hpx * s) / 2;
      c.clearRect(0, 0, W, H);
      c.fillStyle = '#d8c29a'; c.fillRect(oX + 0, oY + world.avenueY * T * s, world.wpx * s, world.AV * T * s);
      zones.forEach(function (z) {
        c.fillStyle = S.zonesVisited[z._i] ? (THEMES[z.theme] || {}).accent || '#8cc' : 'rgba(160,170,160,0.6)';
        c.globalAlpha = S.zonesVisited[z._i] ? 0.9 : 0.5;
        c.fillRect(oX + z._px * T * s, oY + z._py * T * s, z._pw * T * s, z._ph * T * s);
      });
      c.globalAlpha = 1;
      var tgt = questGetTarget();
      if (tgt) { var tx2 = tgt.x != null ? tgt.x : tgt.cx, ty2 = tgt.y != null ? tgt.y : tgt.cy; c.fillStyle = 'rgba(240,180,50,' + (0.5 + 0.5 * Math.abs(Math.sin(gt * 4))) + ')'; c.beginPath(); c.arc(oX + tx2 * s, oY + ty2 * s, 4, 0, 7); c.fill(); }
      c.fillStyle = '#e0532a'; c.beginPath(); c.arc(oX + player.x * s, oY + player.y * s, 3, 0, 7); c.fill();
      c.strokeStyle = '#fff'; c.lineWidth = 1; c.stroke();
    }

    // ==========================================================================
    //  CART (Shopify Cart AJAX API)
    // ==========================================================================
    var Cart = (function () {
      var subtotal = 0, itemCount = 0, busy = false;
      function add(p) {
        if (busy) return; busy = true;
        var btn = card && card.querySelector('[data-add]'); if (btn) { btn.disabled = true; btn.textContent = t('adding'); }
        flyToCart(p);
        fetch(cfg.routes.cartAdd, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: p.vid, quantity: 1 }], sections: 'cart-icon-bubble', sections_url: location.pathname })
        }).then(function (r) { return r.json(); }).then(function (data) {
          busy = false;
          if (data && data.sections && data.sections['cart-icon-bubble']) updateBubble(data.sections['cart-icon-bubble']);
          Audio2.sfx('cart');
          if (!S.discovered[p.id]) { S.discovered[p.id] = true; }
          addXp(3); S.coins += 1;
          toast('🛒 ' + t('added')); say(t('added'));
          fire('add_to_cart', { id: p.id, variant_id: p.vid, title: p.title, price: p.price });
          if (btn) { btn.disabled = false; btn.textContent = '✓ ' + t('added'); setTimeout(function () { if (btn) btn.textContent = t('add_to_cart'); }, 1400); }
          refresh(); updateHud();
        }).catch(function () {
          busy = false; Audio2.sfx('error'); toast('⚠️ ' + 'נסו שוב');
          if (btn) { btn.disabled = false; btn.textContent = t('add_to_cart'); }
        });
      }
      function refresh() {
        return fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          subtotal = c.items_subtotal_price != null ? c.items_subtotal_price : c.total_price;
          itemCount = c.item_count; updateMeter(); checkRewards(); return c;
        }).catch(function () { return null; });
      }
      function updateBubble(html) {
        var node = document.getElementById('cart-icon-bubble');
        if (node) { var tmp = el('div', null, html); var inner = tmp.querySelector('#cart-icon-bubble') || tmp.firstElementChild; if (inner) node.innerHTML = inner.innerHTML; }
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      }
      return { add: add, refresh: refresh, get sub() { return subtotal; }, get count() { return itemCount; } };
    })();

    function flyToCart(p) {
      if (S.reduced || !p.img) return;
      var rect = canvas.getBoundingClientRect();
      var img = card && card.querySelector('.dga-card__img');
      var from = img ? img.getBoundingClientRect() : { left: rect.left + rect.width / 2, top: rect.top + rect.height - 60, width: 40, height: 40 };
      var fly = el('img', 'dga-fly'); fly.src = p.img;
      fly.style.left = (from.left - rect.left) + 'px'; fly.style.top = (from.top - rect.top) + 'px';
      overlays.appendChild(fly);
      var target = hud && hud.coins ? hud.coins.getBoundingClientRect() : { left: rect.left + 30, top: rect.top + 20 };
      requestAnimationFrame(function () {
        fly.style.transform = 'translate(' + ((target.left - from.left)) + 'px,' + ((target.top - from.top)) + 'px) scale(0.3)';
        fly.style.opacity = '0';
      });
      setTimeout(function () { fly.remove(); }, 750);
    }

    // ==========================================================================
    //  PRODUCT CARD
    // ==========================================================================
    var card = null;
    function suitLabel(s) { return s === 'home' ? t('suit_home') : s === 'garden' ? t('suit_garden') : t('suit_both'); }
    function diffClass(d) { return /קל/.test(d) ? 'easy' : /קשה/.test(d) ? 'hard' : 'mid'; }
    function money(cents) { var n = cents / 100; return '₪' + n.toLocaleString('he-IL', { maximumFractionDigits: (n % 1 ? 2 : 0) }); }

    function openCard(p, ref) {
      if (card && card._pid === p.id) return;
      closeCard();
      var z = zone || {}, def = z.def || {};
      var diff = p.diff || def.difficulty || 'בינוני';
      var water = p.water || def.water || '';
      var light = p.light || def.light || '';
      var suit = p.suit || def.suit || 'both';
      var care = p.care || def.care || '';
      var c = el('div', 'dga-card'); c._pid = p.id; c._auto = !!ref;
      var rows = '';
      if (water && water !== '—') rows += careRow('💧', t('watering'), water);
      if (light && light !== '—') rows += careRow('☀️', t('light'), light);
      rows += careRow('🏡', t('suits'), suitLabel(suit));
      if (care) rows += careRow('🌱', t('care'), care);
      c.innerHTML =
        '<button class="dga-card__close" data-close aria-label="סגור">✕</button>' +
        '<div class="dga-card__head">' +
          (p.img ? '<img class="dga-card__img" src="' + p.img + '" alt="" loading="lazy">' : '<div class="dga-card__img"></div>') +
          '<div class="dga-card__info">' +
            '<h3 class="dga-card__title">' + esc(p.title) + '</h3>' +
            '<div><span class="dga-card__price">' + money(p.price) + '</span>' + (p.cmp && p.cmp > p.price ? '<span class="dga-card__cmp">' + money(p.cmp) + '</span>' : '') + '</div>' +
            '<div class="dga-badges">' +
              '<span class="dga-badge dga-badge--cat">' + esc(z.name || '') + '</span>' +
              '<span class="dga-badge dga-badge--' + diffClass(diff) + '">' + esc(diff) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="dga-care">' + rows + '</div>' +
        '<div class="dga-card__cta">' +
          '<button class="dga-btn" data-add>' + t('add_to_cart') + '</button>' +
          '<a class="dga-card__link" href="' + p.url + '" target="_top">' + t('view_product') + '</a>' +
        '</div>';
      overlays.appendChild(c); card = c;
      on(c.querySelector('[data-close]'), 'click', closeCard);
      on(c.querySelector('[data-add]'), 'click', function () { Cart.add(p); });
      if (!S.discovered[p.id]) { S.discovered[p.id] = true; addXp(1); save(); updateHud(); }
      fire('product_view', { id: p.id, title: p.title, zone: z.name });
      Audio2.sfx('pickup');
    }
    function careRow(ico, lbl, val) { return '<div class="dga-care__row"><span class="dga-care__ico">' + ico + '</span><span class="dga-care__lbl">' + lbl + ':</span><span>' + esc(val) + '</span></div>'; }
    function closeCard() { if (card) { card.remove(); card = null; } }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

    // ==========================================================================
    //  PROGRESSION / XP / REWARDS
    // ==========================================================================
    function need(lvl) { return 4 + lvl * 2; }
    function addXp(n) {
      S.xp += n; var leveled = false;
      while (S.xp >= need(S.level)) { S.xp -= need(S.level); S.level++; leveled = true; onLevelUp(); }
      if (!leveled) updateHud();
      save();
    }
    function onLevelUp() {
      S.cosmetic = Math.min(3, Math.floor(S.level / 2));
      Audio2.sfx('level');
      flashLevel(S.level);
      toast('⭐ ' + t('level_up', { x: S.level }), 'xp'); say(t('level_up', { x: S.level }));
      fire('level_up', { level: S.level });
      updateHud(); checkRewards();
    }
    function flashLevel(n) {
      if (S.reduced) return;
      var f = el('div', 'dga-levelup', '<div class="dga-levelup__inner">⭐ ' + t('level') + ' ' + n + '</div>');
      overlays.appendChild(f); setTimeout(function () { f.remove(); }, 1100);
    }

    function condMet(cond) {
      switch (cond) {
        case 'level2': return S.level >= 2 || count(S.mgCleared) >= 1;
        case 'level4': return S.level >= 4 || count(S.zonesVisited) >= 3;
        case 'meter': return Cart.sub >= cfg.threshold * 100 && cfg.threshold > 0;
        case 'finish': return S.finished;
      }
      return false;
    }
    var giftQueue = [], giftOpen = false;
    function checkRewards() {
      if (!cfg.rewardsEnabled || !started) return;
      (cfg.codes || []).forEach(function (cd) {
        if (S.codes[cd.id]) return;
        if (condMet(cd.cond)) { S.codes[cd.id] = true; save(); giftQueue.push(cd); }
      });
      if (giftQueue.length && !giftOpen) showNextGift();
    }
    function showNextGift() {
      var cd = giftQueue.shift(); if (!cd) return; giftOpen = true;
      Audio2.sfx('gift');
      openLayer(buildGift(cd), function () { giftOpen = false; if (giftQueue.length) showNextGift(); });
    }

    // ==========================================================================
    //  TREASURES + DAILY GIFT
    // ==========================================================================
    function collectTreasure(tr) {
      S.treasureIds[tr.key] = true; S.treasures++;
      var reward = 3 + Math.floor(Math.random() * 4); S.coins += reward; addXp(2);
      Audio2.sfx('coin'); toast('🎁 ' + t('treasure_found', { x: reward }), 'gold'); say(t('treasure_found', { x: reward }));
      save(); updateHud();
    }
    function dailyGift() {
      var today = new Date().toISOString().slice(0, 10);
      var key = 'dga:daily:' + sectionId;
      var last; try { last = localStorage.getItem(key); } catch (e) {}
      if (last === today) return null;
      return {
        claim: function () {
          var reward = 5 + Math.floor(Math.random() * 6); S.coins += reward; save(); updateHud();
          try { localStorage.setItem(key, today); } catch (e) {}
          Audio2.sfx('coin'); return reward;
        }
      };
    }

    // ==========================================================================
    //  OVERLAY / LAYER MANAGER (pausing modals)
    // ==========================================================================
    var layers = [];
    function openLayer(node, onClose) {
      var lay = el('div', 'dga-layer'); lay.appendChild(node); lay.__onClose = onClose || null;
      on(lay, 'click', function (e) { if (e.target === lay && node.getAttribute('data-nodismiss') == null) closeLayer(lay); });
      overlays.appendChild(lay); layers.push(lay);
      paused = true; // loop keeps drawing; paused halts world updates
      trapFocus(lay);
      return lay;
    }
    function closeLayer(lay) {
      if (!lay || lay.__closed) return; lay.__closed = true;
      var i = layers.indexOf(lay); if (i >= 0) layers.splice(i, 1);
      if (lay.__onClose) { try { lay.__onClose(); } catch (e) {} }
      lay.remove(); if (layers.length === 0) { paused = false; }
      if (canvas && started) canvas.focus({ preventScroll: true });
    }
    function closeTopLayer() { if (layers.length) closeLayer(layers[layers.length - 1]); }
    function trapFocus(node) {
      var f = node.querySelectorAll('button,a,input,[tabindex]'); if (f.length) f[0].focus();
    }

    function modal(opts) {
      var p = el('div', 'dga-panel');
      if (opts.nodismiss) p.setAttribute('data-nodismiss', '1');
      p.setAttribute('role', 'dialog'); p.setAttribute('aria-modal', 'true');
      if (opts.title) p.appendChild(el('h2', null, opts.title));
      var close = el('button', 'dga-panel__close', '✕'); close.setAttribute('aria-label', 'סגור');
      p.appendChild(close);
      var body = el('div', 'dga-panel__body'); p.appendChild(body);
      if (typeof opts.body === 'string') body.innerHTML = opts.body; else if (opts.body) body.appendChild(opts.body);
      var lay = openLayer(p, opts.onClose);
      function done() { closeLayer(lay); }
      on(close, 'click', done);
      return { node: p, body: body, close: done };
    }

    // ==========================================================================
    //  GIFT REVEAL
    // ==========================================================================
    function buildGift(cd) {
      var p = el('div', 'dga-panel dga-gift'); p.setAttribute('role', 'dialog'); p.setAttribute('aria-modal', 'true');
      p.innerHTML =
        '<h2>' + t('gift_title') + '</h2>' +
        '<p>' + esc(cd.label || '') + '</p>' +
        '<div class="dga-gift__box" tabindex="0" role="button" aria-label="' + t('gift_open') + '">🎁</div>' +
        '<p class="dga-gift__hint">' + t('gift_open') + '</p>' +
        '<div class="dga-gift__reveal">' +
          '<div class="dga-codebox"><code>' + esc(cd.code) + '</code></div>' +
          '<div class="dga-gift__actions">' +
            '<button class="dga-btn dga-btn--ghost" data-copy>' + t('copy') + '</button>' +
            '<a class="dga-btn dga-btn--gold" data-apply href="/discount/' + encodeURIComponent(cd.code) + '?redirect=/checkout">' + t('apply_checkout') + '</a>' +
          '</div>' +
        '</div>' +
        '<button class="dga-btn dga-btn--block" data-ok style="margin-top:12px">' + t('keep_playing') + '</button>';
      var box = p.querySelector('.dga-gift__box'), reveal = p.querySelector('.dga-gift__reveal'), hint = p.querySelector('.dga-gift__hint');
      function openBox() { box.classList.add('is-open'); reveal.classList.add('is-shown'); hint.style.display = 'none'; Audio2.sfx('win'); burstConfetti(12); }
      on(box, 'click', openBox); on(box, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openBox(); } });
      if (S.reduced) openBox();
      on(p.querySelector('[data-copy]'), 'click', function (e) { copyText(cd.code, e.target); });
      on(p.querySelector('[data-apply]'), 'click', function () { fire('checkout_click', { via: 'gift', code: cd.code }); });
      on(p.querySelector('[data-ok]'), 'click', function () { closeTopLayer(); });
      return p;
    }
    function copyText(txt, btn) {
      var ok = function () { if (btn) { var o = btn.textContent; btn.textContent = t('copied'); setTimeout(function () { btn.textContent = o; }, 1500); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok).catch(fallback);
      else fallback();
      function fallback() { try { var ta = el('textarea'); ta.value = txt; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); ok(); } catch (e) {} }
    }

    // ==========================================================================
    //  CONFETTI + TOAST + LIVE
    // ==========================================================================
    function burstConfetti(n) {
      if (S.reduced) return;
      var wrap = el('div', 'dga-confetti'); overlays.appendChild(wrap);
      var colors = ['#22b572', '#f3b73d', '#e0532a', '#3b82f6', '#9b59b6', '#fff'];
      for (var i = 0; i < (n || 40); i++) {
        var p = el('i'); p.style.left = Math.random() * 100 + '%';
        p.style.background = colors[i % colors.length];
        p.style.animationDuration = (1.6 + Math.random() * 1.6) + 's';
        p.style.animationDelay = (Math.random() * 0.4) + 's';
        p.style.transform = 'rotate(' + (Math.random() * 360) + 'deg)';
        wrap.appendChild(p);
      }
      setTimeout(function () { wrap.remove(); }, 3600);
    }
    var toastWrap = null;
    function toast(msg, kind) {
      if (!toastWrap) { toastWrap = el('div', 'dga-toasts'); overlays.appendChild(toastWrap); }
      var node = el('div', 'dga-toast' + (kind ? ' dga-toast--' + kind : ''), esc(msg));
      toastWrap.appendChild(node);
      setTimeout(function () { node.style.opacity = '0'; node.style.transform = 'translateY(-8px)'; setTimeout(function () { node.remove(); }, 300); }, 2000);
    }
    function say(msg) { if (liveEl) liveEl.textContent = msg; }

    // ==========================================================================
    //  HUD
    // ==========================================================================
    var hud = null;
    function buildHud() {
      var h = el('div', 'dga-hud');
      h.innerHTML =
        '<div class="dga-hud__left">' +
          '<div style="display:flex;gap:8px;flex-wrap:wrap">' +
            '<span class="dga-chip"><span class="dga-chip__lvl" data-lvl>1</span><span data-xpw></span></span>' +
            '<span class="dga-chip dga-chip__coins">🪙 <span data-coins>0</span></span>' +
          '</div>' +
          '<div class="dga-xp"><div class="dga-xp__fill" data-xp></div></div>' +
          '<span class="dga-zonepill" data-zone></span>' +
        '</div>' +
        '<div class="dga-hud__right">' +
          '<button class="dga-iconbtn" data-mute aria-label="' + t('audio') + '">🔊</button>' +
          '<button class="dga-iconbtn" data-quest aria-label="' + t('quest') + '">📜</button>' +
          '<button class="dga-iconbtn" data-mapbtn aria-label="' + t('map') + '">🗺️</button>' +
          '<button class="dga-iconbtn" data-menu aria-label="' + t('menu') + '">☰</button>' +
        '</div>';
      overlays.appendChild(h);
      var mm = el('div', 'dga-minimap'); var mcv = el('canvas', 'dga-minimap__cv'); mcv.width = 132; mcv.height = 84; mm.appendChild(mcv);
      var ql = el('div', 'dga-questline'); mm.appendChild(ql); overlays.appendChild(mm);
      // meter
      var m = el('div', 'dga-meter');
      m.innerHTML = '<span class="dga-meter__icon">🚚</span><div class="dga-meter__track"><span class="dga-meter__fill" data-meter></span></div><span data-metertxt></span>';
      overlays.appendChild(m);
      // controls
      var ctrls = el('div', 'dga-controls');
      ctrls.innerHTML =
        '<div class="dga-dpad">' +
          '<button class="dga-dpad__btn dga-dpad__up" data-dir="up" aria-label="למעלה">▲</button>' +
          '<button class="dga-dpad__btn dga-dpad__left" data-dir="left" aria-label="שמאלה">◀</button>' +
          '<span class="dga-dpad__mid"></span>' +
          '<button class="dga-dpad__btn dga-dpad__right" data-dir="right" aria-label="ימינה">▶</button>' +
          '<button class="dga-dpad__btn dga-dpad__down" data-dir="down" aria-label="למטה">▼</button>' +
        '</div>' +
        '<button class="dga-act" data-act>' + t('action') + '</button>';
      overlays.appendChild(ctrls);

      hud = {
        root: h, meter: m, ctrls: ctrls,
        lvl: h.querySelector('[data-lvl]'), xp: h.querySelector('[data-xp]'), coins: h.querySelector('[data-coins]'),
        zone: h.querySelector('[data-zone]'), meterFill: m.querySelector('[data-meter]'), meterTxt: m.querySelector('[data-metertxt]'),
        act: ctrls.querySelector('[data-act]'), mute: h.querySelector('[data-mute]'), meterBox: m, mini: mcv, questline: ql
      };
      // bind controls
      on(hud.act, 'click', function () { doAction(); });
      ctrls.querySelectorAll('[data-dir]').forEach(function (b) {
        var dir = b.getAttribute('data-dir');
        var set = function (v) { if (dir === 'left') dpad.x = v ? -1 : (dpad.x === -1 ? 0 : dpad.x); else if (dir === 'right') dpad.x = v ? 1 : (dpad.x === 1 ? 0 : dpad.x); else if (dir === 'up') dpad.y = v ? -1 : (dpad.y === -1 ? 0 : dpad.y); else dpad.y = v ? 1 : (dpad.y === 1 ? 0 : dpad.y); b.classList.toggle('is-down', !!v); };
        on(b, 'pointerdown', function (e) { e.preventDefault(); Audio2.ensure(); set(1); });
        on(b, 'pointerup', function (e) { e.preventDefault(); set(0); });
        on(b, 'pointerleave', function () { set(0); });
        on(b, 'pointercancel', function () { set(0); });
      });
      on(hud.mute, 'click', toggleMute);
      on(h.querySelector('[data-mapbtn]'), 'click', openMap);
      on(h.querySelector('[data-quest]'), 'click', openQuestLog);
      on(h.querySelector('[data-menu]'), 'click', openMenu);
      // touch detection: hide dpad for non-touch (keyboard) users
      if (!('ontouchstart' in window) && !(navigator.maxTouchPoints > 0) && !window.matchMedia('(pointer: coarse)').matches) root.classList.add('dga--no-touch');
      updateHud(); questUpdateHud();
    }
    function setActionHot(hot) { if (hud && hud.act) hud.act.classList.toggle('is-hot', !!hot); }
    function updateHud() {
      if (!hud) return;
      hud.lvl.textContent = S.level; hud.coins.textContent = S.coins;
      hud.xp.style.width = clamp(S.xp / need(S.level) * 100, 0, 100) + '%';
      if (zone) hud.zone.textContent = (ZONE_EMOJI[zone.theme] || '🌿') + ' ' + (zone.name || '');
      // meter
      var thr = cfg.threshold * 100;
      if (cfg.threshold <= 0) { hud.meterBox.style.display = 'none'; return; }
      var pct = clamp(Cart.sub / thr * 100, 0, 100);
      hud.meterFill.style.width = pct + '%';
      hud.meterBox.classList.toggle('is-full', Cart.sub >= thr);
      hud.meterTxt.textContent = Cart.sub >= thr ? t('free_ship') + ' ✓' : t('to_free_ship', { x: money(thr - Cart.sub) });
    }
    function updateMeter() {
      var was = root.__meterFull;
      updateHud();
      if (cfg.threshold > 0 && Cart.sub >= cfg.threshold * 100 && !was) {
        root.__meterFull = true; Audio2.sfx('win'); toast(t('free_ship_hit'), 'gold'); burstConfetti(20);
      }
    }

    function toggleMute() {
      S.muted = !S.muted; Audio2.ensure(); Audio2.setMute(S.muted); save();
      if (hud && hud.mute) { hud.mute.textContent = S.muted ? '🔈' : '🔊'; hud.mute.setAttribute('aria-pressed', S.muted ? 'true' : 'false'); }
      if (!S.muted) Audio2.startMusic();
    }

    // ==========================================================================
    //  FAST-TRAVEL MAP + MENU
    // ==========================================================================
    function openMap() {
      var b = el('div');
      var cv = el('canvas', 'dga-bigmap'); cv.width = 320; cv.height = 200; b.appendChild(cv);
      var c = cv.getContext('2d'), W = cv.width, H = cv.height;
      var s = Math.min((W - 8) / world.wpx, (H - 8) / world.hpx), oX = (W - world.wpx * s) / 2, oY = (H - world.hpx * s) / 2;
      c.fillStyle = '#eef3ec'; c.fillRect(0, 0, W, H);
      c.fillStyle = '#d8c29a'; c.fillRect(oX, oY + world.avenueY * T * s, world.wpx * s, world.AV * T * s);
      zones.forEach(function (z) {
        c.globalAlpha = S.zonesVisited[z._i] ? 0.92 : 0.42; c.fillStyle = (THEMES[z.theme] || {}).accent || '#8cc';
        c.fillRect(oX + z._px * T * s, oY + z._py * T * s, z._pw * T * s, z._ph * T * s);
        c.globalAlpha = 1; c.font = '11px serif'; c.textAlign = 'center'; c.textBaseline = 'middle';
        c.fillText((ZONE_EMOJI[z.theme] || ''), oX + z.cx * s, oY + z.cy * s);
      });
      c.fillStyle = '#e0532a'; c.beginPath(); c.arc(oX + player.x * s, oY + player.y * s, 4, 0, 7); c.fill();
      c.strokeStyle = '#fff'; c.lineWidth = 1.5; c.stroke();
      b.appendChild(el('p', 'dga-map__hint', '🎯 ' + questHintText()));
      modal({ title: '🗺️ ' + t('map'), body: b });
    }

    function openMenu() {
      var body = el('div');
      var list = el('div', 'dga-menu__list');
      function item(label, fn, cls) { var b = el('button', 'dga-btn ' + (cls || 'dga-btn--ghost') + ' dga-btn--block', label); on(b, 'click', fn); list.appendChild(b); return b; }
      item('▶️ ' + t('resume'), function () { m.close(); });
      item('🗺️ ' + t('map'), function () { m.close(); openMap(); });
      item('🎮 ' + t('minigames'), function () { m.close(); openMinigamePicker(); });
      item('⚙️ ' + t('settings'), function () { m.close(); openSettings(); });
      item('🏁 ' + t('finish'), function () { m.close(); endGame(); }, 'dga-btn--gold');
      item('🔄 ' + t('restart'), function () { if (confirm('להתחיל מחדש? ההתקדמות במשחק תתאפס.')) { resetGame(); m.close(); } });
      if (cfg.showSkip) { var a = el('a', 'dga-btn dga-btn--block dga-menu-skip', '🚪 ' + t('skip')); a.href = cfg.routes.all; a.style.background = 'transparent'; a.style.color = 'var(--dga-ink-soft)'; a.style.boxShadow = 'inset 0 0 0 2px var(--dga-line)'; list.appendChild(a); }
      body.appendChild(list);
      var m = modal({ title: '☰ ' + t('menu'), body: body });
    }

    function openSettings() {
      var body = el('div', 'dga-options');
      body.appendChild(segRow(t('pace'), [['explore', t('pace_explore')], ['challenge', t('pace_challenge')]], S.pace, function (v) { S.pace = v; save(); }));
      body.appendChild(toggleRow([
        [t('calm'), S.calm, function (v) { S.calm = v; save(); }],
        [t('audio'), !S.muted, function (v) { S.muted = !v; Audio2.ensure(); Audio2.setMute(S.muted); if (!S.muted) Audio2.startMusic(); if (hud && hud.mute) hud.mute.textContent = S.muted ? '🔈' : '🔊'; save(); }],
        [t('reduce_motion'), S.reduced, function (v) { S.reduced = v; applyA11y(); save(); }],
        [t('contrast'), S.contrast, function (v) { S.contrast = v; applyA11y(); save(); }]
      ]));
      body.appendChild(segRow(t('text_size'), [['1', 'A'], ['1.15', 'A+'], ['1.3', 'A++']], String(S.textScale), function (v) { S.textScale = parseFloat(v); applyA11y(); save(); }));
      modal({ title: '⚙️ ' + t('settings'), body: body });
    }
    function segRow(label, opts, current, onPick) {
      var wrap = el('div', 'dga-opt'); wrap.appendChild(el('span', 'dga-opt__label', label));
      var seg = el('div', 'dga-seg');
      opts.forEach(function (o) {
        var b = el('button', null, o[1]); b.setAttribute('aria-pressed', o[0] === current ? 'true' : 'false');
        on(b, 'click', function () { seg.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); onPick(o[0]); });
        seg.appendChild(b);
      });
      wrap.appendChild(seg); return wrap;
    }
    function toggleRow(items) {
      var wrap = el('div', 'dga-opt'); var box = el('div', 'dga-toggles');
      items.forEach(function (it) {
        var lab = el('label', 'dga-toggle'); var inp = el('input'); inp.type = 'checkbox'; inp.checked = !!it[1];
        on(inp, 'change', function () { it[2](inp.checked); }); lab.appendChild(inp); lab.appendChild(document.createTextNode(it[0])); box.appendChild(lab);
      });
      wrap.appendChild(box); return wrap;
    }

    function applyA11y() {
      root.classList.toggle('dga--reduced-motion', S.reduced || window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      root.classList.toggle('dga--contrast', S.contrast);
      root.style.setProperty('--dga-text-scale', S.textScale);
    }

    function openMinigamePicker() {
      var body = el('div', 'dga-menu__list');
      var types = ['fertilizer', 'pests', 'repotting', 'watering', 'light', 'doctor', 'propagation', 'trivia'];
      types.forEach(function (ty) {
        var done = S.mgCleared[ty] ? ' ✓' : '';
        var b = el('button', 'dga-btn dga-btn--ghost dga-btn--block', (MG_EMOJI[ty] || '🎮') + ' ' + (MG_TITLE[ty] || ty) + done);
        on(b, 'click', function () { closeTopLayer(); openMinigame(ty); });
        body.appendChild(b);
      });
      modal({ title: '🎮 ' + t('minigames'), body: body });
    }

    function resetGame() {
      try { localStorage.removeItem(SAVE_KEY); } catch (e) {}
      S.level = 1; S.xp = 0; S.coins = 0; S.zoneIndex = 0; S.discovered = {}; S.treasureIds = {}; S.treasures = 0;
      S.mgCleared = {}; S.zonesVisited = {}; S.codes = {}; S.cosmetic = 0; S.finished = false; S.playMs = 0;
      S.npcDone = false; S.quest = null; S.finaleDone = false; S.introSeen = false;
      save(); root.__meterFull = false; zone = null; parts.length = 0;
      player.x = world.spawn.x; player.y = world.spawn.y; player.dir = 'up'; camCenter(player.x, player.y); updateCamera(0, true);
      updateHud(); questUpdateHud(); startIntro(function () { S.introSeen = true; talkNpc(); });
    }

    // ==========================================================================
    //  START + END SCREENS
    // ==========================================================================
    var started = false;
    function showStart() {
      if (bootEl) bootEl.remove();
      var hasSave = S.level > 1 || count(S.zonesVisited) > 0 || count(S.discovered) > 0;
      var p = el('div', 'dga-panel dga-start'); p.setAttribute('data-nodismiss', '1'); p.setAttribute('role', 'dialog');
      var daily = dailyGift();
      p.innerHTML =
        '<div class="dga-start__art" aria-hidden="true">🌱</div>' +
        '<h2>' + esc(cfg.title || 'הרפתקה בדקו גרדן') + '</h2>' +
        '<div class="dga-start__intro rte">' + (cfg.intro || '') + '</div>' +
        '<div class="dga-options">' +
          '<div class="dga-opt"><span class="dga-opt__label">' + t('pace') + '</span><div class="dga-seg" data-pace>' +
            '<button data-v="explore" aria-pressed="true">' + t('pace_explore') + '</button>' +
            '<button data-v="challenge" aria-pressed="false">' + t('pace_challenge') + '</button></div></div>' +
          '<div class="dga-opt"><span class="dga-opt__label">' + t('accessibility') + '</span><div class="dga-toggles" data-toggles>' +
            tgl('calm', t('calm'), S.calm) + tgl('audio', t('audio'), !S.muted && cfg.audio) +
            tgl('reduced', t('reduce_motion'), S.reduced) + tgl('contrast', t('contrast'), S.contrast) +
          '</div></div>' +
        '</div>' +
        (daily ? '<button class="dga-btn dga-btn--gold dga-btn--block" data-daily style="margin-bottom:10px">🎁 ' + t('daily_claim') + '</button>' : '') +
        '<button class="dga-btn dga-btn--lg dga-btn--block" data-start>' + (hasSave ? t('continue_game') : (cfg.startLabel || t('start_game'))) + ' 🌿</button>' +
        (cfg.showSkip ? '<a class="dga__skip-link" href="' + cfg.routes.all + '">' + t('skip') + '</a>' : '');
      var lay = openLayer(p);
      // pace
      p.querySelectorAll('[data-pace] button').forEach(function (b) { on(b, 'click', function () { p.querySelectorAll('[data-pace] button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); S.pace = b.getAttribute('data-v'); }); });
      // toggles
      p.querySelectorAll('[data-toggles] input').forEach(function (inp) {
        on(inp, 'change', function () {
          var key = inp.getAttribute('data-k'), v = inp.checked;
          if (key === 'calm') S.calm = v;
          else if (key === 'audio') { S.muted = !v; }
          else if (key === 'reduced') { S.reduced = v; applyA11y(); }
          else if (key === 'contrast') { S.contrast = v; applyA11y(); }
        });
      });
      if (daily) on(p.querySelector('[data-daily]'), 'click', function (e) { var r = daily.claim(); e.target.textContent = '🎉 ' + t('daily_got', { x: r }); e.target.disabled = true; });
      on(p.querySelector('[data-start]'), 'click', function () { closeLayer(lay); beginGame(); });
    }
    function tgl(k, label, on_) { return '<label class="dga-toggle"><input type="checkbox" data-k="' + k + '"' + (on_ ? ' checked' : '') + '>' + label + '</label>'; }

    function beginGame() {
      started = true; applyA11y(); save();
      Audio2.ensure(); if (cfg.audio && !S.muted) Audio2.startMusic();
      if (!hud) buildHud();
      resize();
      player.x = world.spawn.x; player.y = world.spawn.y; player.dir = 'up';
      camCenter(player.x, player.y); updateCamera(0, true);
      startLoop();
      if (cfg.threshold > 0) Cart.refresh();
      fire('game_start', { pace: S.pace });
      canvas.focus({ preventScroll: true });
      if (!S.introSeen) { S.introSeen = true; save(); startIntro(function () { talkNpc(); }); }
      else { questUpdateHud(); if (!S.npcDone) talkNpc(); }
    }

    function endGame() {
      S.finished = true; save(); checkRewards();
      fire('game_complete', { level: S.level, discovered: count(S.discovered), treasures: S.treasures, minigames: count(S.mgCleared), playMs: S.playMs });
      var p = el('div', 'dga-panel dga-end'); p.setAttribute('data-nodismiss', '1');
      var mins = Math.floor(S.playMs / 60000), secs = Math.floor(S.playMs % 60000 / 1000);
      var claimed = (cfg.codes || []).filter(function (c) { return S.codes[c.id]; });
      p.innerHTML =
        '<div class="dga-end__art" aria-hidden="true">🏆</div>' +
        '<h2>' + t('end_title') + '</h2>' +
        '<div class="dga-stats">' +
          stat(mins + ':' + (secs < 10 ? '0' : '') + secs, t('time_played')) +
          stat(count(S.discovered), t('plants_found')) +
          stat(S.level, t('level')) +
          stat(S.treasures, t('treasures')) +
        '</div>' +
        (claimed.length ? '<div class="dga-codes" data-codes></div>' : '') +
        '<div class="dga-cartsum" data-cartsum><p>' + t('cart_summary') + '…</p></div>' +
        '<a class="dga-btn dga-btn--lg dga-btn--block" data-checkout style="margin-top:10px" href="' + cfg.routes.checkout + '">🛒 ' + t('checkout') + '</a>' +
        '<button class="dga-btn dga-btn--ghost dga-btn--block" data-resume style="margin-top:8px">' + t('keep_playing') + '</button>';
      var lay = openLayer(p);
      burstConfetti(60); Audio2.sfx('win');
      if (claimed.length) {
        var cwrap = p.querySelector('[data-codes]');
        claimed.forEach(function (c) {
          var row = el('div', 'dga-codes__item');
          row.innerHTML = '<span>' + esc(c.label) + ' <span class="dga-codes__code">' + esc(c.code) + '</span></span>';
          var b = el('button', 'dga-btn dga-btn--ghost', t('copy')); on(b, 'click', function (e) { copyText(c.code, e.target); }); row.appendChild(b);
          cwrap.appendChild(row);
        });
      }
      // cart summary
      Cart.refresh().then(function (c) {
        var box = p.querySelector('[data-cartsum]');
        if (!c || !c.items || !c.items.length) { box.innerHTML = '<p>' + t('empty_cart') + '</p>'; return; }
        var html = '';
        c.items.slice(0, 6).forEach(function (it) { html += '<div class="dga-cartsum__row"><span>' + esc(it.title) + ' ×' + it.quantity + '</span><span>' + money(it.line_price) + '</span></div>'; });
        html += '<div class="dga-cartsum__row dga-cartsum__total"><span>' + t('cart_summary') + '</span><span>' + money(c.items_subtotal_price) + '</span></div>';
        box.innerHTML = html;
      });
      on(p.querySelector('[data-checkout]'), 'click', function () { fire('checkout_click', { via: 'end' }); });
      on(p.querySelector('[data-resume]'), 'click', function () { closeLayer(lay); });
    }
    function stat(num, lbl) { return '<div class="dga-stat"><div class="dga-stat__num">' + num + '</div><div class="dga-stat__lbl">' + lbl + '</div></div>'; }

    // ==========================================================================
    //  MINI-GAMES
    // ==========================================================================
    function zoneProductsByMinigame(type) {
      for (var i = 0; i < zones.length; i++) if (zones[i].minigame === type && zones[i].products.length) return zones[i].products;
      return [];
    }
    function recommendProduct(type) { var arr = zoneProductsByMinigame(type); return arr.length ? arr[Math.floor(Math.random() * arr.length)] : null; }
    function mgWin(type, coins) {
      var fresh = !S.mgCleared[type]; if (fresh) S.mgCleared[type] = true;
      S.coins += coins || 5; addXp(5); save(); updateHud();
      Audio2.sfx('win'); burstConfetti(24); fire('minigame_clear', { type: type });
      if (fresh) questHelpedPlant();
      checkRewards();
    }
    function challenge() { return S.pace === 'challenge' && !S.calm; }

    function mgShell(type, introHtml, build) {
      var body = el('div');
      var intro = el('p', 'dga-mg__hint', introHtml);
      body.appendChild(intro);
      var stage = el('div', 'dga-mg__stage'); body.appendChild(stage);
      var foot = el('div', 'dga-mg__foot');
      var skip = el('button', 'dga-btn dga-btn--ghost', t('skip_mg')); foot.appendChild(skip);
      var status = el('div', 'dga-mg__score', ''); foot.appendChild(status);
      body.appendChild(foot);
      var m = modal({ title: (MG_EMOJI[type] || '🎮') + ' ' + (MG_TITLE[type] || ''), body: body, onClose: function () { if (api.onClose) api.onClose(); } });
      on(skip, 'click', m.close);
      var api = { stage: stage, status: status, foot: foot, close: m.close, intro: intro, onClose: null,
        winUI: function (msg, extra) { winPanel(body, stage, type, msg, extra, m); } };
      build(api);
      return api;
    }
    function winPanel(body, stage, type, msg, extra, m) {
      stage.innerHTML = '<div style="position:absolute;inset:0;display:grid;place-content:center;text-align:center;gap:8px;padding:14px">' +
        '<div style="font-size:46px">🎉</div><div style="font-weight:800;font-size:18px">' + (msg || t('win')) + '</div>' +
        (extra || '') + '</div>';
    }
    function recommendButton(type, label) {
      var p = recommendProduct(type); if (!p) return '';
      return '<div class="dga-rec" data-vid="' + p.vid + '" data-id="' + p.id + '" data-price="' + p.price + '" data-title="' + esc(p.title) + '"' + (p.img ? ' data-img="' + esc(p.img) + '"' : '') + '>' +
        '<div style="font-size:13px;color:var(--dga-ink-soft);margin:8px 0 6px">' + (label || t('recommend')) + ' ' + esc(p.title) + ' · ' + money(p.price) + '</div>' +
        '<button class="dga-btn dga-btn--block" data-recadd>' + t('add_to_cart') + '</button></div>';
    }
    function wireRecommend(scope) {
      var box = scope.querySelector('.dga-rec'); if (!box) return;
      var b = box.querySelector('[data-recadd]'); if (!b) return;
      on(b, 'click', function () {
        var p = { vid: +box.getAttribute('data-vid'), id: +box.getAttribute('data-id'), title: box.getAttribute('data-title'), price: +box.getAttribute('data-price'), img: box.getAttribute('data-img') || null };
        Cart.add(p); b.textContent = '✓ ' + t('added'); b.disabled = true;
      });
    }

    function openMinigame(type) {
      Audio2.ensure();
      switch (type) {
        case 'fertilizer': return mgFertilizer();
        case 'pests': return mgPests();
        case 'repotting': return mgRepot();
        case 'watering': return mgWater();
        case 'light': return mgLight();
        case 'doctor': return mgDoctor();
        case 'propagation': return mgProp();
        case 'trivia': return mgTrivia();
        default: toast('בקרוב!');
      }
    }

    // 1) Fertilizer station — feed → HP fills, plant flourishes
    function mgFertilizer() {
      mgShell('fertilizer', 'הזינו את הצמח בדשן עד שיפרח! לחצו "הזן".', function (api) {
        var hp = 0, goal = challenge() ? 6 : 4, stages = ['🌱', '🌿', '🪴', '🌳', '🌸'];
        api.stage.innerHTML = '<div class="dga-grow" data-plant>🌱</div>';
        var bar = el('div', 'dga-mg__bar', '<i data-fill></i>'); api.stage.appendChild(bar);
        bar.style.position = 'absolute'; bar.style.left = '12%'; bar.style.right = '12%'; bar.style.bottom = '12px';
        var feed = el('button', 'dga-btn', '🧪 ' + t('feed')); api.foot.insertBefore(feed, api.status);
        var plant = api.stage.querySelector('[data-plant]'), fill = api.stage.querySelector('[data-fill]');
        on(feed, 'click', function () {
          hp++; Audio2.sfx('pickup'); fill.style.width = clamp(hp / goal * 100, 0, 100) + '%';
          plant.textContent = stages[Math.min(stages.length - 1, Math.round(hp / goal * (stages.length - 1)))];
          plant.style.transform = 'scale(' + (1 + hp / goal * 0.6) + ')';
          if (hp >= goal) { feed.remove(); mgWin('fertilizer', 6); api.winUI(t('win') + ' הצמח פורח! 🌸', recommendButton('fertilizer', 'דשן מומלץ:')); wireRecommend(api.stage); }
        });
      });
    }

    // 2) Pest control — friendly whack-the-bug
    function mgPests() {
      mgShell('pests', 'מחצו את החרקים עם תרסיס ההדברה! ' + (challenge() ? '20 שניות.' : 'הגיעו ל-8.'), function (api) {
        var score = 0, goal = 8, alive = true, holes = [];
        for (var i = 0; i < 6; i++) { var h = el('div', 'dga-bug'); h.style.left = (15 + (i % 3) * 30) + '%'; h.style.top = (25 + Math.floor(i / 3) * 40) + '%'; api.stage.appendChild(h); holes.push(h); }
        api.status.textContent = '0 / ' + goal;
        var emojis = ['🦟', '🐛', '🐜', '🪲'];
        function pop() {
          if (!alive) return;
          var h = holes[Math.floor(Math.random() * holes.length)];
          if (h.classList.contains('is-up')) return;
          h.textContent = emojis[Math.floor(Math.random() * emojis.length)]; h.classList.add('is-up');
          var ttl = challenge() ? 700 : 1000;
          setTimeout(function () { h.classList.remove('is-up'); }, ttl);
        }
        holes.forEach(function (h) {
          on(h, 'pointerdown', function () {
            if (!h.classList.contains('is-up') || h.classList.contains('is-hit')) return;
            h.classList.add('is-hit'); Audio2.sfx('bug'); score++; api.status.textContent = score + ' / ' + goal;
            setTimeout(function () { h.classList.remove('is-up'); h.classList.remove('is-hit'); }, 160);
            if (score >= goal) finish(true);
          });
        });
        var iv = setInterval(pop, challenge() ? 480 : 650);
        var timer = null;
        if (challenge()) { var left = 20; api.status.textContent = score + ' / ' + goal + ' · ⏱️' + left; timer = setInterval(function () { left--; api.status.textContent = score + ' / ' + goal + ' · ⏱️' + left; if (left <= 0) finish(score >= goal); }, 1000); }
        function finish(won) { alive = false; clearInterval(iv); if (timer) clearInterval(timer); if (won) { mgWin('pests', 7); api.winUI('הדברתם את המזיקים! 🐞', recommendButton('pests', 'תרסיס מומלץ:')); wireRecommend(api.stage); } else { Audio2.sfx('error'); api.status.textContent = t('try_again'); var rt = el('button', 'dga-btn', t('try_again')); api.foot.insertBefore(rt, api.status); on(rt, 'click', function () { api.close(); mgPests(); }); } }
        api.onClose = function () { alive = false; clearInterval(iv); if (timer) clearInterval(timer); };
      });
    }

    // 3) Repotting — drag plant into correctly sized pot
    function mgRepot() {
      mgShell('repotting', 'גררו את הצמח לעציץ בגודל הנכון 🌱→🏺', function (api) {
        var sizes = [['קטן', 54], ['בינוני', 70], ['גדול', 88]];
        var correct = 1 + Math.floor(Math.random() * 2); // medium/large needed
        var plantSize = correct; // plant matches one pot
        api.intro.textContent = 'הצמח גדל — מצא לו עציץ ' + sizes[correct][0] + '!';
        var pots = [];
        sizes.forEach(function (sz, i) {
          var d = el('div', 'dga-drop'); d.style.width = sz[1] + 'px'; d.style.height = sz[1] + 'px';
          d.style.bottom = '14px'; d.style.left = (12 + i * 30) + '%'; d.innerHTML = '🏺<br>' + sz[0]; d._i = i;
          api.stage.appendChild(d); pots.push(d);
        });
        var plant = el('div', 'dga-drag', '🪴'); plant.style.left = '42%'; plant.style.top = '8%'; api.stage.appendChild(plant);
        makeDraggable(plant, api.stage, pots, function (pot) {
          if (pot && pot._i === correct) { pot.classList.add('is-good'); mgWin('repotting', 5); api.winUI('עציץ מושלם! 🏺', recommendButton('repotting', 'כד מומלץ:')); wireRecommend(api.stage); }
          else if (pot) { pot.classList.add('is-bad'); Audio2.sfx('error'); setTimeout(function () { pot.classList.remove('is-bad'); plant.style.left = '42%'; plant.style.top = '8%'; plant.style.transform = ''; }, 500); }
        });
      });
    }

    // 4) Watering challenge — stop the needle in the target band
    function mgWater() {
      mgShell('watering', t('tap_stop') + ' 💧', function (api) {
        var target = 30 + Math.random() * 40, band = challenge() ? 9 : 16;
        var gauge = el('div', 'dga-gauge'); gauge.style.position = 'absolute'; gauge.style.left = '8%'; gauge.style.right = '8%'; gauge.style.top = '45%';
        gauge.innerHTML = '<div class="dga-gauge__target"></div><div class="dga-gauge__needle"></div>';
        api.stage.appendChild(gauge);
        var tgt = gauge.querySelector('.dga-gauge__target'), needle = gauge.querySelector('.dga-gauge__needle');
        tgt.style.left = (target - band) + '%'; tgt.style.width = (band * 2) + '%';
        var plant = el('div', null, '🪴'); plant.style.position = 'absolute'; plant.style.fontSize = '46px'; plant.style.left = '50%'; plant.style.top = '12%'; plant.style.transform = 'translateX(-50%)'; api.stage.appendChild(plant);
        var pos = 0, dir = 1, speed = challenge() ? 1.3 : 0.9, raf, stopped = false;
        function step() { if (stopped) return; pos += dir * speed; if (pos >= 100) { pos = 100; dir = -1; } if (pos <= 0) { pos = 0; dir = 1; } needle.style.left = pos + '%'; raf = requestAnimationFrame(step); }
        step();
        var btn = el('button', 'dga-btn', '💧 ' + t('water_now')); api.foot.insertBefore(btn, api.status);
        on(btn, 'click', function () {
          if (stopped) return; stopped = true; cancelAnimationFrame(raf); btn.remove();
          var diff = Math.abs(pos - target);
          if (diff <= band) { plant.textContent = '🌿'; mgWin('watering', 5); api.winUI('השקיה מושלמת! 🌿'); }
          else { plant.textContent = pos > target ? '💧🥀' : '🏜️🥀'; Audio2.sfx('error'); api.status.textContent = pos > target ? 'יותר מדי מים…' : 'מעט מדי מים…'; var rt = el('button', 'dga-btn', t('try_again')); api.foot.insertBefore(rt, api.status); on(rt, 'click', function () { api.close(); mgWater(); }); }
        });
        api.onClose = function () { stopped = true; cancelAnimationFrame(raf); };
      });
    }

    // 5) Light match — drag plant into sun or shade
    function mgLight() {
      mgShell('light', t('drag_hint') + ' ☀️/🌑', function (api) {
        var needSun = Math.random() < 0.5;
        api.intro.textContent = needSun ? 'הצמח אוהב שמש מלאה — לאן נשים אותו? ☀️' : 'הצמח אוהב צל / אור עקיף — לאן נשים אותו? 🌑';
        var sun = el('div', 'dga-drop', '☀️<br>שמש'); sun.style.width = '38%'; sun.style.height = '46%'; sun.style.left = '6%'; sun.style.bottom = '12px'; sun._sun = true;
        var shade = el('div', 'dga-drop', '🌑<br>צל'); shade.style.width = '38%'; shade.style.height = '46%'; shade.style.right = '6%'; shade.style.bottom = '12px'; shade._sun = false;
        api.stage.appendChild(sun); api.stage.appendChild(shade);
        var plant = el('div', 'dga-drag', needSun ? '🌻' : '🌿'); plant.style.left = '42%'; plant.style.top = '6%'; api.stage.appendChild(plant);
        makeDraggable(plant, api.stage, [sun, shade], function (drop) {
          if (!drop) return;
          if (drop._sun === needSun) { drop.classList.add('is-good'); mgWin('light', 5); api.winUI('בול! הצמח מרוצה 😊'); }
          else { drop.classList.add('is-bad'); Audio2.sfx('error'); setTimeout(function () { drop.classList.remove('is-bad'); plant.style.left = '42%'; plant.style.top = '6%'; plant.style.transform = ''; }, 500); }
        });
      });
    }

    // 6) Plant doctor — diagnose symptom → recommend product
    function mgDoctor() {
      var cases = [
        { s: 'העלים מצהיבים והאדמה כל הזמן רטובה 💛', opts: ['השקיית יתר', 'חוסר אור', 'מזיקים'], a: 0, rec: 'repotting', tip: 'בחרו כד עם ניקוז טוב והשקו רק כשהמצע מתייבש.' },
        { s: 'כתמים דביקים וקורים דקים על העלים 🕸️', opts: ['מזיקים', 'עודף שמש', 'חוסר דשן'], a: 0, rec: 'pests', tip: 'טפלו בתרסיס הדברה ידידותי, משני צידי העלה.' },
        { s: 'הצמיחה איטית והעלים חיוורים 🍃', opts: ['חוסר דשן', 'יותר מדי מים', 'קור'], a: 0, rec: 'fertilizer', tip: 'דשנו בעונת הצמיחה לפי ההוראות שעל האריזה.' },
        { s: 'השורשים מציצים מהתחתית והצמח נראה "צפוף" 🌱', opts: ['העציץ נהיה קטן', 'יותר מדי שמש', 'חוסר מים'], a: 0, rec: 'repotting', tip: 'הגיע הזמן להעביר לעציץ גדול יותר.' }
      ];
      var cs = cases[Math.floor(Math.random() * cases.length)];
      mgShell('doctor', 'מה הבעיה? ' + cs.s, function (api) {
        api.stage.style.aspectRatio = 'auto'; api.stage.style.minHeight = '0'; api.stage.style.background = 'transparent';
        var ch = el('div', 'dga-choices'); api.stage.appendChild(ch);
        cs.opts.forEach(function (o, i) {
          var b = el('button', 'dga-choice', o);
          on(b, 'click', function () {
            if (i === cs.a) { b.classList.add('is-correct'); mgWin('doctor', 6);
              api.intro.innerHTML = '✅ ' + esc(cs.tip);
              var rec = el('div', null, recommendButton(cs.rec, t('recommend'))); api.stage.appendChild(rec); wireRecommend(rec);
              ch.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
            } else { b.classList.add('is-wrong'); Audio2.sfx('error'); }
          });
          ch.appendChild(b);
        });
      });
    }

    // 7) Propagation — timing: stop marker in the root zone
    function mgProp() {
      mgShell('propagation', t('tap_stop') + ' 🌿', function (api) {
        var zoneStart = 35 + Math.random() * 25, zoneW = challenge() ? 12 : 20;
        var bar = el('div', 'dga-timing'); bar.style.position = 'absolute'; bar.style.left = '8%'; bar.style.right = '8%'; bar.style.top = '45%';
        bar.innerHTML = '<div class="dga-timing__zone"></div><div class="dga-timing__marker"></div>'; api.stage.appendChild(bar);
        var z = bar.querySelector('.dga-timing__zone'), mk = bar.querySelector('.dga-timing__marker');
        z.style.left = zoneStart + '%'; z.style.width = zoneW + '%';
        var cut = el('div', null, '✂️🌿'); cut.style.position = 'absolute'; cut.style.fontSize = '40px'; cut.style.left = '50%'; cut.style.top = '10%'; cut.style.transform = 'translateX(-50%)'; api.stage.appendChild(cut);
        var pos = 0, dir = 1, sp = challenge() ? 1.5 : 1.0, raf, stopped = false;
        function step() { if (stopped) return; pos += dir * sp; if (pos >= 100 || pos <= 0) dir *= -1; mk.style.left = clamp(pos, 0, 100) + '%'; raf = requestAnimationFrame(step); } step();
        var btn = el('button', 'dga-btn', '🌿 ' + t('root_it')); api.foot.insertBefore(btn, api.status);
        on(btn, 'click', function () {
          if (stopped) return; stopped = true; cancelAnimationFrame(raf); btn.remove();
          if (pos >= zoneStart && pos <= zoneStart + zoneW) { cut.textContent = '🌱✨'; mgWin('propagation', 6); api.winUI('הייחור השריש! 🌱'); }
          else { Audio2.sfx('error'); api.status.textContent = t('try_again'); var rt = el('button', 'dga-btn', t('try_again')); api.foot.insertBefore(rt, api.status); on(rt, 'click', function () { api.close(); mgProp(); }); }
        });
        api.onClose = function () { stopped = true; cancelAnimationFrame(raf); };
      });
    }

    // 8) Trivia quiz
    function mgTrivia() {
      var bank = [
        { q: 'כל כמה זמן כדאי בדרך כלל לדשן צמחי בית בעונת הצמיחה?', o: ['פעם בשבועיים–שלושה', 'כל יום', 'פעם בשנה'], a: 0 },
        { q: 'מה מהבאים מסייע לסוקולנט להישאר בריא?', o: ['מצע מנקז ופחות מים', 'הרבה מים וצל', 'בלי אור בכלל'], a: 0 },
        { q: 'איך נדע שצמח צמא?', o: ['המצע יבש כמה ס"מ לעומק', 'העלים מבריקים', 'יש פרחים'], a: 0 },
        { q: 'מה עוזר לצמח טרופי שאוהב לחות?', o: ['ריסוס עלים / מגש לחות', 'שמש ישירה חזקה', 'אוויר יבש ממזגן'], a: 0 },
        { q: 'מתי הכי טוב להעביר צמח לעציץ גדול יותר?', o: ['כשהשורשים מציצים מהתחתית', 'אף פעם', 'כשהוא פורח'], a: 0 }
      ];
      var qs = bank.slice().sort(function () { return Math.random() - 0.5; }).slice(0, 3), idx = 0, correct = 0;
      mgShell('trivia', '', function (api) {
        api.stage.style.aspectRatio = 'auto'; api.stage.style.minHeight = '0'; api.stage.style.background = 'transparent';
        function render() {
          var cq = qs[idx]; api.intro.textContent = '❓ ' + cq.q; api.status.textContent = (idx + 1) + ' / ' + qs.length;
          api.stage.innerHTML = ''; var ch = el('div', 'dga-choices'); api.stage.appendChild(ch);
          cq.o.forEach(function (o, i) {
            var b = el('button', 'dga-choice', o);
            on(b, 'click', function () {
              ch.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
              if (i === cq.a) { b.classList.add('is-correct'); correct++; Audio2.sfx('coin'); S.coins += 2; addXp(2); updateHud(); }
              else { b.classList.add('is-wrong'); Audio2.sfx('error'); ch.children[cq.a].classList.add('is-correct'); }
              setTimeout(function () { idx++; if (idx < qs.length) render(); else finish(); }, 850);
            });
            ch.appendChild(b);
          });
        }
        function finish() { if (correct >= 2) { mgWin('trivia', correct * 2); api.intro.textContent = ''; api.winUI('ענית נכון על ' + correct + ' מתוך ' + qs.length + '! 🧠'); } else { Audio2.sfx('error'); api.intro.textContent = 'ענית נכון על ' + correct + '. ' + t('try_again'); api.stage.innerHTML = ''; var rt = el('button', 'dga-btn dga-btn--block', t('try_again')); api.stage.appendChild(rt); on(rt, 'click', function () { api.close(); mgTrivia(); }); } }
        render();
      });
    }

    // shared drag helper (pointer + touch) for repot/light
    function makeDraggable(node, stage, drops, onDrop) {
      var dragging = false, sr = null;
      on(node, 'pointerdown', function (e) {
        e.preventDefault(); dragging = true; node.classList.add('is-grab'); sr = stage.getBoundingClientRect();
        node.setPointerCapture && node.setPointerCapture(e.pointerId);
      });
      on(node, 'pointermove', function (e) {
        if (!dragging) return;
        var x = e.clientX - sr.left - node.offsetWidth / 2, y = e.clientY - sr.top - node.offsetHeight / 2;
        node.style.left = clamp(x, 0, sr.width - node.offsetWidth) + 'px'; node.style.top = clamp(y, 0, sr.height - node.offsetHeight) + 'px'; node.style.transform = 'none';
        var over = hitDrop(); drops.forEach(function (d) { d.classList.toggle('is-over', d === over); });
      });
      on(node, 'pointerup', function (e) {
        if (!dragging) return; dragging = false; node.classList.remove('is-grab');
        var over = hitDrop(); drops.forEach(function (d) { d.classList.remove('is-over'); });
        onDrop(over);
      });
      function hitDrop() {
        var nr = node.getBoundingClientRect(), cx = nr.left + nr.width / 2, cy = nr.top + nr.height / 2;
        for (var i = 0; i < drops.length; i++) { var dr = drops[i].getBoundingClientRect(); if (cx >= dr.left && cx <= dr.right && cy >= dr.top && cy <= dr.bottom) return drops[i]; }
        return null;
      }
    }

    // ==========================================================================
    //  BOOT
    // ==========================================================================
    load();
    applyA11y();
    if (cfg.threshold > 0) Cart.refresh(); // prime meter from existing cart
    // resize handling
    if ('ResizeObserver' in window) { new ResizeObserver(function () { resize(); }).observe(frame); }
    on(window, 'resize', resize);
    on(window, 'orientationchange', function () { setTimeout(resize, 200); });
    // first gesture unlocks audio
    var unlock = function () { Audio2.ensure(); if (cfg.audio && !S.muted && started) Audio2.startMusic(); window.removeEventListener('pointerdown', unlock); };
    on(window, 'pointerdown', unlock);

    // draw a still preview of the nursery behind the start screen
    player.x = world.spawn.x; player.y = world.spawn.y; player.dir = 'down';
    camCenter(player.x, player.y); resize(); updateCamera(0, true); draw();
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
      window.__dgaWarp = function (tx, ty) { player.x = tx * T; player.y = ty * T; var rz = regionAt(player.x, player.y); if (rz) zone = rz; camCenter(player.x, player.y); updateCamera(0, true); };
      window.__dgaWarpZone = function (i) { var z = zones[i]; if (!z) return; player.x = z.cx; player.y = (z.bounds.y1 - 1.5) * T; var rz = regionAt(player.x, player.y); if (rz) zone = rz; camCenter(player.x, player.y); updateCamera(0, true); };
      window.__dgaWorld = world;
    }
    showStart();
  }
})();
